(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jwfLogin"] = factory();
	else
		root["jwfLogin"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _modelStore = __webpack_require__(6);
	
	var _modelStore2 = _interopRequireDefault(_modelStore);
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	var _uiActions = __webpack_require__(11);
	
	var _uiActions2 = _interopRequireDefault(_uiActions);
	
	var _platformDetection = __webpack_require__(64);
	
	var _platformDetection2 = _interopRequireDefault(_platformDetection);
	
	var _coreParamManager = __webpack_require__(69);
	
	var _coreParamManager2 = _interopRequireDefault(_coreParamManager);
	
	var _paramManager = __webpack_require__(68);
	
	var _paramManager2 = _interopRequireDefault(_paramManager);
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _formVariant = __webpack_require__(15);
	
	var _formVariant2 = _interopRequireDefault(_formVariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!_platformDetection2.default.os.isSupported || !_platformDetection2.default.browser.isSupported) {
	    throw new Error('Login component is not supported on this platform!!!');
	}
	
	var jwfLoginComponentId = 0,
	    createInstance = function createInstance() {
	    var componentId = jwfLoginComponentId++;
	
	    return {
	        // Latest supported public interface
	        ApiV2: {
	            // Initialize the component
	            init: function init(params) {
	                // Create models
	                _paramStore2.default.registerComponent(componentId);
	                _modelStore2.default.registerComponent(componentId);
	                _uiStateStore2.default.registerComponent(componentId);
	                // Handle global parameters
	                _coreParamManager2.default.validateAndStore(params, componentId);
	                _paramManager2.default.validateAndStore(params, componentId);
	            },
	            // Retrieve unique identifier of this instance
	            getInstanceId: function getInstanceId() {
	                return componentId;
	            },
	            // Render login and/or registration form
	            createForm: function createForm(placeHolder) {
	                _uiActions2.default.createFormV2(placeHolder, componentId);
	            },
	            getFormType: function getFormType() {
	                return _formType2.default;
	            },
	            getFormVariant: function getFormVariant() {
	                return _formVariant2.default;
	            }
	        },
	
	        // Previous deprecated public interface
	        Api: {
	            // Discontinue, no more providing Bubble experience
	            initBubble: function initBubble(placeHolder, params) {
	                _coreParamManager2.default.warnImplementer('Api.initBubble');
	                _uiActions2.default.initBubble(placeHolder, params, componentId);
	            },
	            // Discontinue, no more providing Bubble experience
	            showBubble: function showBubble(event) {
	                _coreParamManager2.default.warnImplementer('Api.showBubble');
	                _uiActions2.default.showBubble(event, componentId);
	            },
	            // Discontinue, no more providing Bubble experience
	            hideBubble: function hideBubble() {
	                _coreParamManager2.default.warnImplementer('Api.hideBubble');
	                _uiActions2.default.hideBubble(componentId);
	            },
	            // Reborn in ApiV2
	            createForm: function createForm(placeHolder, params) {
	                _coreParamManager2.default.warnImplementer('Api.createForm');
	                _uiActions2.default.createForm(placeHolder, params, componentId);
	            },
	            // Reborn in core layer
	            getClsLoginUrl: function getClsLoginUrl() {
	                _coreParamManager2.default.warnImplementer('Api.getClsLoginUrl');
	                return _uiActions2.default.getClsLoginUrl(componentId);
	            }
	        },
	        // Reborn in ApiV2
	        FormType: _formType2.default,
	        // Reborn in ApiV2
	        FormVariant: _formVariant2.default,
	
	        // Private interface
	        _Api: {
	            trackUiEvent: function trackUiEvent(trackingValue, cId) {
	                _uiActions2.default.trackUiEvent(trackingValue, cId ? cId : componentId);
	            },
	            showProductInformation: function showProductInformation(cId) {
	                _uiActions2.default.showProductInformation(cId ? cId : componentId);
	            },
	            Links: {
	                termsLinkClicked: function termsLinkClicked(cId) {
	                    _uiActions2.default.termsLinkClicked(cId ? cId : componentId);
	                },
	                privacyLinkClicked: function privacyLinkClicked(cId) {
	                    _uiActions2.default.privacyLinkClicked(cId ? cId : componentId);
	                },
	                federatedLoginLinkClicked: function federatedLoginLinkClicked(clsLoginUrl, cId) {
	                    _uiActions2.default.federatedLoginLinkClicked(clsLoginUrl, cId ? cId : componentId);
	                },
	                existingLoginLinkClicked: function existingLoginLinkClicked(hasPassword, cId) {
	                    _uiActions2.default.existingLoginLinkClicked(hasPassword, cId ? cId : componentId);
	                }
	            }
	        }
	    };
	};
	
	var moduleExports = createInstance();
	moduleExports.createInstance = createInstance;
	module.exports = moduleExports;

/***/ },
/* 1 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _initialCohort = __webpack_require__(4);
	
	var _initialCohort2 = _interopRequireDefault(_initialCohort);
	
	var _targetCohort = __webpack_require__(5);
	
	var _targetCohort2 = _interopRequireDefault(_targetCohort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParamStore = function (_EventEmitter) {
	    _inherits(ParamStore, _EventEmitter);
	
	    function ParamStore() {
	        _classCallCheck(this, ParamStore);
	
	        var _this = _possibleConstructorReturn(this, (ParamStore.__proto__ || Object.getPrototypeOf(ParamStore)).call(this));
	
	        _this.CHANGE_EVENT = 'PARAM_CHANGE_EVENT';
	
	        _this._model = {};
	        return _this;
	    }
	
	    _createClass(ParamStore, [{
	        key: 'registerComponent',
	        value: function registerComponent(componentId) {
	            this._model['c' + componentId] = {
	                instanceId: 'unknown-jwf-login-implementer',
	
	                rootUrl: '/',
	                initialCohort: _initialCohort2.default.singlePasswordRegistration,
	                targetCohort: _targetCohort2.default.loggedInStartTab,
	
	                clsEndpoint: '',
	                clsClientId: '',
	                clsReturnUrl: '',
	                clsLoginUrl: '',
	                clsAutoLoginReturnUrl: '',
	                websiteEndpoint: '',
	                disableRedirectToLogin: false,
	                disableKeepLoggedInCheckbox: false,
	
	                targetUrl: null,
	                clsExecutionArea: 'cls-execution-area',
	
	                sentryUrl: '',
	                userLogData: {
	                    anonymousId: '',
	                    lang: '',
	                    phasedRolloutChannel: '',
	                    userVariations: ''
	                },
	
	                lang5: 'en-US',
	                callbacks: {
	                    successfulRegistrationAtClsSide: null,
	                    successfulLoginAtClsSide: null,
	                    successfulRegistrationAtHtml5Side: null,
	                    registration: null
	                },
	
	                tracking: {
	                    segment: {
	                        containerProperty: 'unknown-jwf-login-implementer',
	                        registrationSource: 'unknown-jwf-login-implementer',
	                        loginSource: 'unknown-jwf-login-implementer'
	                    },
	                    ga: {}
	                },
	
	                silentMode: false
	            };
	        }
	    }, {
	        key: 'getModel',
	        value: function getModel(componentId) {
	            if (componentId === undefined || componentId === null) {
	                throw new Error('componentId is missing');
	            }
	
	            return this._model['c' + componentId];
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(this.CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(this.CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'update',
	        value: function update(componentId, updateFn) {
	            if (updateFn) {
	                updateFn(this.getModel(componentId));
	            }
	
	            this.emit(this.CHANGE_EVENT);
	        }
	    }]);
	
	    return ParamStore;
	}(EventEmitter);
	
	var paramStore = new ParamStore();
	paramStore.setMaxListeners(1000000);
	exports.default = paramStore;

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    startMeetingDownload: 0,
	    standardRegistration: 1,
	    singlePasswordRegistration: 2,
	    passwordlessRegistration: 3
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    loggedInStartTab: 0,
	    loggedInStartShortUrl: 1
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _passwordMode = __webpack_require__(8);
	
	var _passwordMode2 = _interopRequireDefault(_passwordMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModelStore = function (_EventEmitter) {
	    _inherits(ModelStore, _EventEmitter);
	
	    function ModelStore() {
	        _classCallCheck(this, ModelStore);
	
	        var _this = _possibleConstructorReturn(this, (ModelStore.__proto__ || Object.getPrototypeOf(ModelStore)).call(this));
	
	        _this.CHANGE_EVENT = 'MODEL_CHANGE_EVENT';
	
	        _this._model = {};
	        return _this;
	    }
	
	    _createClass(ModelStore, [{
	        key: 'registerComponent',
	        value: function registerComponent(componentId) {
	            this._model['c' + componentId] = {
	                formType: _formType2.default.login,
	                email: '',
	                password: '',
	                confirmedPassword: '',
	                passwordMode: _passwordMode2.default.standard,
	                keepLoggedIn: false,
	                acceptTerms: false,
	                sendProductInformation: true,
	                validation: this.emptyValidationModel
	            };
	        }
	    }, {
	        key: 'getModel',
	        value: function getModel(componentId) {
	
	            if (componentId === undefined || componentId === null) {
	                throw new Error('componentId is missing');
	            }
	
	            return this._model['c' + componentId];
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(this.CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(this.CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'update',
	        value: function update(componentId, updateFn) {
	            if (updateFn) {
	                updateFn(this.getModel(componentId));
	            }
	
	            this.emit(this.CHANGE_EVENT);
	        }
	    }, {
	        key: 'updateAsync',
	        value: function updateAsync(componentId, updateFn) {
	            var _this2 = this;
	
	            var promise = updateFn(this.getModel(componentId)).then(function () {
	                _this2.emit(_this2.CHANGE_EVENT);
	            });
	
	            this.emit(this.CHANGE_EVENT);
	
	            return promise;
	        }
	    }, {
	        key: 'emptyValidationModel',
	        get: function get() {
	            return {
	                errors: {
	                    email: '',
	                    password: '',
	                    confirmedPassword: '',
	                    acceptTerms: '',
	                    submitError: ''
	                },
	                hasErrors: false,
	                hasEmailBeenEdited: false,
	                hasEmailBeenValid: false,
	                hasPasswordBeenEdited: false,
	                hasPasswordBeenValid: false,
	                hasConfirmedPasswordBeenEdited: false,
	                hasConfirmedPasswordBeenValid: false
	            };
	        }
	    }]);
	
	    return ModelStore;
	}(EventEmitter);
	
	var modelStore = new ModelStore();
	modelStore.setMaxListeners(1000000);
	exports.default = modelStore;

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    login: 0,
	    register: 1,
	    forgotPassword: 2
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    standard: 0,
	    singlePassword: 1,
	    passwordless: 2
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _uiState = __webpack_require__(10);
	
	var _uiState2 = _interopRequireDefault(_uiState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UiStateStore = function (_EventEmitter) {
	    _inherits(UiStateStore, _EventEmitter);
	
	    function UiStateStore() {
	        _classCallCheck(this, UiStateStore);
	
	        var _this = _possibleConstructorReturn(this, (UiStateStore.__proto__ || Object.getPrototypeOf(UiStateStore)).call(this));
	
	        _this.CHANGE_EVENT = 'UI_STATE_CHANGE_EVENT';
	
	        _this._model = {};
	        return _this;
	    }
	
	    _createClass(UiStateStore, [{
	        key: 'registerComponent',
	        value: function registerComponent(componentId) {
	            this._model['c' + componentId] = {
	                bubble: {
	                    bubblePlaceholder: null,
	                    isBubbleRendered: false,
	                    isBubbleVisible: false,
	                    position: {
	                        top: 0,
	                        left: 0,
	                        overflow: 0,
	                        width: 385
	                    }
	                },
	                form: {
	                    uiState: _uiState2.default.initial,
	                    formPlaceholder: null,
	                    showProductInformation: false,
	                    formVariants: [],
	                    localizationOverrides: []
	                }
	            };
	        }
	    }, {
	        key: 'getModel',
	        value: function getModel(componentId) {
	
	            if (componentId === undefined || componentId === null) {
	                throw new Error('componentId is missing');
	            }
	
	            return this._model['c' + componentId];
	        }
	    }, {
	        key: 'addChangeListener',
	        value: function addChangeListener(callback) {
	            this.on(this.CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'removeChangeListener',
	        value: function removeChangeListener(callback) {
	            this.removeListener(this.CHANGE_EVENT, callback);
	        }
	    }, {
	        key: 'update',
	        value: function update(componentId, updateFn) {
	            if (updateFn) {
	                updateFn(this.getModel(componentId));
	            }
	
	            this.emit(this.CHANGE_EVENT);
	        }
	    }]);
	
	    return UiStateStore;
	}(EventEmitter);
	
	var uiStateStore = new UiStateStore();
	uiStateStore.setMaxListeners(1000000);
	exports.default = uiStateStore;

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    initial: 'initial',
	    ready: 'ready',
	    waiting: 'waiting'
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _modelStore = __webpack_require__(6);
	
	var _modelStore2 = _interopRequireDefault(_modelStore);
	
	var _bubblePositionCalculator = __webpack_require__(12);
	
	var _bubblePositionCalculator2 = _interopRequireDefault(_bubblePositionCalculator);
	
	var _loginBubble = __webpack_require__(13);
	
	var _loginBubble2 = _interopRequireDefault(_loginBubble);
	
	var _loginForm = __webpack_require__(16);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	var _trackingAction = __webpack_require__(25);
	
	var _trackingAction2 = _interopRequireDefault(_trackingAction);
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _jmServices = __webpack_require__(26);
	
	var _jmServices2 = _interopRequireDefault(_jmServices);
	
	var _errorLogger = __webpack_require__(23);
	
	var _errorLogger2 = _interopRequireDefault(_errorLogger);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _paramManager = __webpack_require__(68);
	
	var _paramManager2 = _interopRequireDefault(_paramManager);
	
	var _coreParamManager = __webpack_require__(69);
	
	var _coreParamManager2 = _interopRequireDefault(_coreParamManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UiActions = function () {
	    function UiActions() {
	        _classCallCheck(this, UiActions);
	    }
	
	    _createClass(UiActions, null, [{
	        key: 'getClsLoginUrl',
	
	
	        // Deprecated
	        value: function getClsLoginUrl(componentId) {
	            return _paramStore2.default.getModel(componentId).clsLoginUrl;
	        }
	
	        // Deprecated
	
	    }, {
	        key: 'createForm',
	        value: function createForm(placeHolder, params, componentId) {
	
	            // Deprecated initialization of component
	            UiActions.registerComponent(componentId);
	            _coreParamManager2.default.validateAndStore(params, componentId);
	            _paramManager2.default.validateAndStore(params, componentId);
	
	            UiActions.createFormV2(placeHolder, componentId);
	        }
	    }, {
	        key: 'createFormV2',
	        value: function createFormV2(placeHolder, componentId) {
	            if (_modelStore2.default.getModel(componentId).formType === _formType2.default.register) {
	                _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsRegisterViewLoaded });
	            }
	
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.form.formPlaceholder = placeHolder;
	            });
	
	            ReactDOM.render(React.createElement(_loginForm2.default, { componentId: componentId }), _uiStateStore2.default.getModel(componentId).form.formPlaceholder);
	        }
	
	        // Discontinue, no more providing Bubble experience
	
	    }, {
	        key: 'initBubble',
	        value: function initBubble(placeHolder, params, componentId) {
	            var _this = this;
	
	            // Deprecated initialization of component
	            UiActions.registerComponent(componentId);
	            _coreParamManager2.default.validateAndStore(params, componentId);
	            _paramManager2.default.validateAndStore(params, componentId);
	
	            try {
	
	                window.Object.defineProperty(Element.prototype, 'documentOffsetTop', {
	                    configurable: true,
	                    get: function get() {
	                        return _this.offsetTop + (_this.offsetParent ? _this.offsetParent.documentOffsetTop : 0);
	                    }
	                });
	
	                window.Object.defineProperty(Element.prototype, 'documentOffsetLeft', {
	                    configurable: true,
	                    get: function get() {
	                        return _this.offsetLeft + (_this.offsetParent ? _this.offsetParent.documentOffsetLeft : 0);
	                    }
	                });
	
	                _uiStateStore2.default.update(componentId, function (model) {
	                    model.bubble.bubblePlaceholder = placeHolder;
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	
	        // Discontinue, no more providing Bubble experience
	
	    }, {
	        key: 'showBubble',
	        value: function showBubble(event, componentId) {
	            event.stopPropagation();
	
	            var render = false;
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.bubble.isBubbleVisible = true;
	                model.bubble.position = _bubblePositionCalculator2.default.calculatePosition(event);
	                render = !model.bubble.isBubbleRendered;
	            });
	
	            if (render) {
	                UiActions._renderBubble(componentId);
	            }
	        }
	
	        // Discontinue, no more providing Bubble experience
	
	    }, {
	        key: 'hideBubble',
	        value: function hideBubble(componentId) {
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.bubble.isBubbleVisible = false;
	            });
	        }
	
	        // Discontinue, no more providing Bubble experience
	
	    }, {
	        key: '_renderBubble',
	        value: function _renderBubble(componentId) {
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.bubble.isBubbleRendered = true;
	
	                ReactDOM.render(React.createElement(_loginBubble2.default, { componentId: componentId }), model.bubble.bubblePlaceholder);
	            });
	        }
	
	        // Deprecated
	
	    }, {
	        key: 'registerComponent',
	        value: function registerComponent(componentId) {
	            _modelStore2.default.registerComponent(componentId);
	            _paramStore2.default.registerComponent(componentId);
	            _uiStateStore2.default.registerComponent(componentId);
	        }
	    }, {
	        key: 'trackUiEvent',
	        value: function trackUiEvent(trackingValue, componentId) {
	            _jmServices2.default.trackEvent(componentId, { trackingValue: trackingValue });
	        }
	    }, {
	        key: 'showProductInformation',
	        value: function showProductInformation(componentId) {
	            _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsChooseOtherwiseLinkClicked });
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.form.showProductInformation = true;
	            });
	        }
	    }, {
	        key: 'termsLinkClicked',
	        value: function termsLinkClicked(componentId) {
	            _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsTermsLinkClicked });
	        }
	    }, {
	        key: 'privacyLinkClicked',
	        value: function privacyLinkClicked(componentId) {
	            _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsPrivacyPolicyLinkClicked });
	        }
	    }, {
	        key: 'existingLoginLinkClicked',
	        value: function existingLoginLinkClicked(hasPassword, componentId) {
	            _jmServices2.default.trackEvent(componentId, {
	                isAsync: false,
	                trackingValue: _trackingAction2.default.jlsAlreadyExistingUserClickedLoginLink
	            }).then(function () {
	                UiActions._openLoginView(hasPassword, componentId);
	            }).catch(function () {
	                UiActions._openLoginView(hasPassword, componentId);
	            });
	        }
	    }, {
	        key: 'federatedLoginLinkClicked',
	        value: function federatedLoginLinkClicked(clsLoginUrl, componentId) {
	            // Aspirin needed for GA page leave tracking as no callback
	            window.setTimeout(function () {
	                _jmServices2.default.trackEvent(componentId, {
	                    isAsync: false,
	                    trackingValue: _trackingAction2.default.jlsFederatedUserClickedLoginLink
	                }).then(function () {
	                    UiActions._redirectAfterLinkClicked(clsLoginUrl);
	                }).catch(function () {
	                    UiActions._redirectAfterLinkClicked(clsLoginUrl);
	                });
	            }, 500);
	        }
	    }, {
	        key: '_openLoginView',
	        value: function _openLoginView(hasPassword, componentId) {
	            if (hasPassword) {
	                _formActions2.default.changeFormType(componentId, _formType2.default.login);
	            } else {
	                // PWD less flow
	                _formActions2.default.redirectToForgotPwd(componentId);
	            }
	        }
	    }, {
	        key: '_redirectAfterLinkClicked',
	        value: function _redirectAfterLinkClicked(url) {
	            window.top.location = url;
	        }
	    }]);
	
	    return UiActions;
	}();
	
	exports.default = UiActions;

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BubblePositionCalculator = function () {
	    function BubblePositionCalculator() {
	        _classCallCheck(this, BubblePositionCalculator);
	    }
	
	    _createClass(BubblePositionCalculator, null, [{
	        key: "calculatePosition",
	        value: function calculatePosition(event) {
	            var target = event.target;
	            if (target.length) {
	                target = target[0];
	            }
	
	            var position = {
	                width: 364
	            };
	
	            position.originX = target.documentOffsetLeft + target.offsetWidth / 2;
	            position.originY = target.documentOffsetTop + target.offsetHeight;
	
	            position.top = position.originY + 35;
	
	            position.left = position.originX - position.width / 2;
	            position.overflow = position.left + position.width - (window.innerWidth - 20);
	
	            if (position.overflow > 0) {
	                position.left -= position.overflow;
	            } else {
	                position.overflow = 0;
	            }
	
	            if (position.left < 0) {
	                position.overflow += position.left - 20;
	                position.left = 20;
	            }
	
	            return position;
	        }
	    }]);
	
	    return BubblePositionCalculator;
	}();
	
	exports.default = BubblePositionCalculator;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _uiActions = __webpack_require__(11);
	
	var _uiActions2 = _interopRequireDefault(_uiActions);
	
	var _loginForm = __webpack_require__(16);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginBubble = function (_LoginComponent) {
	    _inherits(LoginBubble, _LoginComponent);
	
	    function LoginBubble(props) {
	        _classCallCheck(this, LoginBubble);
	
	        return _possibleConstructorReturn(this, (LoginBubble.__proto__ || Object.getPrototypeOf(LoginBubble)).call(this, props));
	    }
	
	    _createClass(LoginBubble, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _get(LoginBubble.prototype.__proto__ || Object.getPrototypeOf(LoginBubble.prototype), 'componentDidMount', this).call(this);
	
	            // We have to break outside of React's scope, because there's no built-in way for a universal
	            // click handler on the whole document. See https://github.com/facebook/react/issues/579
	            var body = document.getElementsByTagName('body')[0];
	            var componentId = this.state.componentId;
	
	            if (body.addEventListener) {
	                body.addEventListener('click', function (e) {
	                    LoginBubble._handleOutsideClick(e, componentId);
	                });
	            } else {
	                // IE8 support
	                body.attachEvent('onclick', function (e) {
	                    LoginBubble._handleOutsideClick(e, componentId);
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var bubbleClass = 'login-component login-bubble' + this.closedClass;
	
	            return React.createElement(
	                'div',
	                { className: 'jwf-login' },
	                React.createElement(
	                    'div',
	                    { id: LoginBubble.id,
	                        className: bubbleClass,
	                        style: this.bubbleStyles },
	                    React.createElement('div', { style: this.arrowStyles,
	                        className: 'bubble-arrow' }),
	                    React.createElement(_loginForm2.default, { svgLoaded: true, componentId: this.state.componentId })
	                )
	            );
	        }
	    }, {
	        key: 'closedClass',
	        get: function get() {
	            return !this.state.uiState.bubble.isBubbleVisible ? ' closed' : '';
	        }
	    }, {
	        key: 'bubbleStyles',
	        get: function get() {
	            var position = this.state.uiState.bubble.position;
	
	            return {
	                top: position.top + 'px',
	                left: position.left + 'px'
	            };
	        }
	    }, {
	        key: 'arrowStyles',
	        get: function get() {
	            var position = this.state.uiState.bubble.position;
	            var arrowHeight = 20;
	            var arrowWidth = 40;
	
	            return {
	                top: -(arrowHeight - 1) + 'px',
	                left: position.width / 2 - arrowWidth / 2 + position.overflow + 'px'
	            };
	        }
	    }], [{
	        key: '_handleCloseClick',
	        value: function _handleCloseClick(componentId) {
	            _uiActions2.default.hideBubble(componentId);
	        }
	    }, {
	        key: '_handleOutsideClick',
	        value: function _handleOutsideClick(event, componentId) {
	            if (!LoginBubble._isClickedInsideBubble(event)) {
	                _uiActions2.default.hideBubble(componentId);
	            }
	        }
	    }, {
	        key: '_isClickedInsideBubble',
	        value: function _isClickedInsideBubble(event) {
	            var element = event.target;
	
	            if (element.getAttribute('id') === LoginBubble.id) {
	                return true;
	            }
	
	            while (element.parentNode && element.parentNode.getAttribute) {
	                element = element.parentNode;
	                if (element.getAttribute('id') === LoginBubble.id) {
	                    return true;
	                }
	            }
	
	            return false;
	        }
	    }, {
	        key: 'id',
	        get: function get() {
	            return 'login-bubble';
	        }
	    }]);
	
	    return LoginBubble;
	}(_loginComponent2.default);
	
	exports.default = LoginBubble;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _formVariant = __webpack_require__(15);
	
	var _formVariant2 = _interopRequireDefault(_formVariant);
	
	var _modelStore = __webpack_require__(6);
	
	var _modelStore2 = _interopRequireDefault(_modelStore);
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginComponent = function (_React$Component) {
	    _inherits(LoginComponent, _React$Component);
	
	    function LoginComponent(props) {
	        _classCallCheck(this, LoginComponent);
	
	        var _this = _possibleConstructorReturn(this, (LoginComponent.__proto__ || Object.getPrototypeOf(LoginComponent)).call(this));
	
	        _this._onModelChange = _this._onModelChange.bind(_this);
	        _this._onUiChange = _this._onUiChange.bind(_this);
	        _this._onParamChange = _this._onParamChange.bind(_this);
	
	        _this.props = props;
	        var componentId = props ? props.componentId : 0;
	
	        _this.state = {
	            componentId: componentId,
	            loginModel: _modelStore2.default.getModel(componentId),
	            uiState: _uiStateStore2.default.getModel(componentId),
	            paramModel: _paramStore2.default.getModel(componentId)
	        };
	        return _this;
	    }
	
	    _createClass(LoginComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            _modelStore2.default.addChangeListener(this._onModelChange);
	            _uiStateStore2.default.addChangeListener(this._onUiChange);
	            _paramStore2.default.addChangeListener(this._onParamChange);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            _modelStore2.default.removeChangeListener(this._onModelChange);
	            _uiStateStore2.default.removeChangeListener(this._onUiChange);
	            _paramStore2.default.removeChangeListener(this._onParamChange);
	        }
	    }, {
	        key: '_onModelChange',
	        value: function _onModelChange() {
	            this.setState({ loginModel: _modelStore2.default.getModel(this.state.componentId) });
	        }
	    }, {
	        key: '_onUiChange',
	        value: function _onUiChange() {
	            this.setState({ uiState: _uiStateStore2.default.getModel(this.state.componentId) });
	        }
	    }, {
	        key: '_onParamChange',
	        value: function _onParamChange() {
	            this.setState({ paramModel: _paramStore2.default.getModel(this.state.componentId) });
	        }
	    }, {
	        key: 'isLogin',
	        get: function get() {
	            return this.state.loginModel.formType === _formType2.default.login;
	        }
	    }, {
	        key: 'isRegister',
	        get: function get() {
	            return this.state.loginModel.formType === _formType2.default.register;
	        }
	    }, {
	        key: 'isLoginOrRegister',
	        get: function get() {
	            return this.isLogin || this.isRegister;
	        }
	    }, {
	        key: 'isMinimal',
	        get: function get() {
	            var isMinimal = false;
	            this.state.uiState.form.formVariants.map(function (variant) {
	                isMinimal |= variant === _formVariant2.default.minimal;
	            });
	            return isMinimal;
	        }
	    }, {
	        key: 'isPromo',
	        get: function get() {
	            var isPromo = false;
	            this.state.uiState.form.formVariants.map(function (variant) {
	                isPromo |= variant === _formVariant2.default.promo;
	            });
	            return isPromo;
	        }
	    }]);
	
	    return LoginComponent;
	}(React.Component);
	
	exports.default = LoginComponent;

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    // Variant of the forms. This values affect both behavior (rendering logic) and ui (css styles).
	    // Please look for both of the usages if modifying the key or the string value.
	    minimal: 'minimal-form',
	    inverted: 'inverted-form',
	    promo: 'promo-form'
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _uiState = __webpack_require__(10);
	
	var _uiState2 = _interopRequireDefault(_uiState);
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _login = __webpack_require__(17);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(55);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _forgotPassword = __webpack_require__(62);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _platformDetection = __webpack_require__(64);
	
	var _platformDetection2 = _interopRequireDefault(_platformDetection);
	
	__webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginForm = function (_LoginComponent) {
	    _inherits(LoginForm, _LoginComponent);
	
	    function LoginForm(props) {
	        _classCallCheck(this, LoginForm);
	
	        var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this, props));
	
	        Raven.config(_this.state.paramModel.sentryUrl, {
	            whitelistUrls: [/jwf-login\.js/],
	            includePaths: [/https?:\/\/.+3amlabs\.net/, /https?:\/\/.+join\.me/]
	        }).install();
	
	        Raven.setExtraContext({
	            user: _this.state.paramModel.userLogData,
	            instanceId: _this.state.paramModel.instanceId
	        });
	        return _this;
	    }
	
	    _createClass(LoginForm, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'div',
	                { className: 'jwf-login' },
	                React.createElement(
	                    'div',
	                    { className: this.formClassName },
	                    this.formUi,
	                    React.createElement('div', { id: this.state.paramModel.clsExecutionArea, className: 'cls-execution-area' })
	                )
	            );
	        }
	    }, {
	        key: 'formUi',
	        get: function get() {
	            if (this.state.uiState.form.uiState === _uiState2.default.initial) {
	                return null;
	            }
	            return this.renderedView;
	        }
	    }, {
	        key: 'renderedView',
	        get: function get() {
	            switch (this.state.loginModel.formType) {
	                case _formType2.default.login:
	                    return React.createElement(_login2.default, { componentId: this.state.componentId });
	                case _formType2.default.register:
	                    return React.createElement(_register2.default, { componentId: this.state.componentId });
	                case _formType2.default.forgotPassword:
	                    return React.createElement(_forgotPassword2.default, { componentId: this.state.componentId });
	                default:
	                    return null;
	            }
	        }
	    }, {
	        key: 'formClassName',
	        get: function get() {
	            var lang = this.state.paramModel.lang5.substring(0, 2);
	            var uiState = this.state.uiState.form.uiState;
	            var className = 'login-component login-form ' + _platformDetection2.default.os.name + ' ' + _platformDetection2.default.browser.name + ' ' + (lang + ' ' + uiState);
	
	            this.state.uiState.form.formVariants.map(function (variant) {
	                className += ' ' + variant;
	            });
	
	            return className;
	        }
	    }]);
	
	    return LoginForm;
	}(_loginComponent2.default);
	
	exports.default = LoginForm;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _emailInput = __webpack_require__(41);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _passwordInput = __webpack_require__(44);
	
	var _passwordInput2 = _interopRequireDefault(_passwordInput);
	
	var _forgotPasswordLink = __webpack_require__(45);
	
	var _forgotPasswordLink2 = _interopRequireDefault(_forgotPasswordLink);
	
	var _keepLoggedInCheckbox = __webpack_require__(47);
	
	var _keepLoggedInCheckbox2 = _interopRequireDefault(_keepLoggedInCheckbox);
	
	var _formHeader = __webpack_require__(51);
	
	var _formHeader2 = _interopRequireDefault(_formHeader);
	
	var _loginSubmitButton = __webpack_require__(53);
	
	var _loginSubmitButton2 = _interopRequireDefault(_loginSubmitButton);
	
	var _localization = __webpack_require__(29);
	
	__webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_LoginComponent) {
	    _inherits(Login, _LoginComponent);
	
	    function Login(props) {
	        _classCallCheck(this, Login);
	
	        return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	    }
	
	    _createClass(Login, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var subTitle = this.isPromo ? '' : React.createElement(
	                'div',
	                { className: 'subtitle-text' },
	                React.createElement(
	                    'span',
	                    null,
	                    (0, _localization.localize)('forms.login.change-or')
	                ),
	                '\xA0',
	                React.createElement(
	                    'a',
	                    {
	                        href: 'javascript:void(0)',
	                        onClick: function onClick() {
	                            return _formActions2.default.changeFormType(_this2.state.componentId, _formType2.default.register);
	                        } },
	                    (0, _localization.localize)('forms.login.change-link')
	                )
	            );
	
	            return React.createElement(
	                'div',
	                { className: 'forms-login' },
	                React.createElement(_formHeader2.default, {
	                    componentId: this.state.componentId,
	                    title: (0, _localization.localize)('forms.login.title'),
	                    subTitle: subTitle }),
	                React.createElement(
	                    'form',
	                    { className: 'login-form-content',
	                        noValidate: 'true',
	                        onSubmit: function onSubmit(e) {
	                            e.preventDefault();
	                            _formActions2.default.login(_this2.state.componentId);
	                        } },
	                    React.createElement(_emailInput2.default, { componentId: this.state.componentId }),
	                    React.createElement(_passwordInput2.default, { componentId: this.state.componentId }),
	                    React.createElement(_forgotPasswordLink2.default, { componentId: this.state.componentId }),
	                    React.createElement(_keepLoggedInCheckbox2.default, { componentId: this.state.componentId }),
	                    React.createElement(_loginSubmitButton2.default, { componentId: this.state.componentId })
	                )
	            );
	        }
	    }]);
	
	    return Login;
	}(_loginComponent2.default);
	
	exports.default = Login;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _modelStore = __webpack_require__(6);
	
	var _modelStore2 = _interopRequireDefault(_modelStore);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	var _uiState = __webpack_require__(10);
	
	var _uiState2 = _interopRequireDefault(_uiState);
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _passwordMode = __webpack_require__(8);
	
	var _passwordMode2 = _interopRequireDefault(_passwordMode);
	
	var _initialCohort = __webpack_require__(4);
	
	var _initialCohort2 = _interopRequireDefault(_initialCohort);
	
	var _clsProviderType = __webpack_require__(39);
	
	var _clsProviderType2 = _interopRequireDefault(_clsProviderType);
	
	var _clsServices = __webpack_require__(21);
	
	var _clsServices2 = _interopRequireDefault(_clsServices);
	
	var _formUiState = __webpack_require__(40);
	
	var _formUiState2 = _interopRequireDefault(_formUiState);
	
	var _trackingAction = __webpack_require__(25);
	
	var _trackingAction2 = _interopRequireDefault(_trackingAction);
	
	var _jmServices = __webpack_require__(26);
	
	var _jmServices2 = _interopRequireDefault(_jmServices);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FormActions = function () {
	    function FormActions() {
	        _classCallCheck(this, FormActions);
	    }
	
	    _createClass(FormActions, null, [{
	        key: 'changeFormType',
	        value: function changeFormType(componentId, formType) {
	            _modelStore2.default.update(componentId, function (model) {
	                if (model.formType !== formType) {
	                    _validator2.default.set(model, _modelStore2.default.emptyValidationModel);
	                }
	                model.formType = formType;
	
	                model.password = '';
	                model.confirmedPassword = '';
	                model.keepLoggedIn = false;
	                model.acceptTerms = false;
	                model.sendProductInformation = true;
	            });
	
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.form.showProductInformation = false;
	            });
	        }
	    }, {
	        key: 'startEditEmail',
	        value: function startEditEmail(componentId) {
	            _validator2.default.enable(componentId);
	        }
	    }, {
	        key: 'endEditEmail',
	        value: function endEditEmail(componentId) {
	            _modelStore2.default.updateAsync(componentId, function (model) {
	                model.validation.hasEmailBeenEdited = true;
	                _validator2.default.clearSubmitError(model);
	                return _validator2.default.validateEmailAsync(componentId, model);
	            });
	        }
	    }, {
	        key: 'changeEmail',
	        value: function changeEmail(componentId, value) {
	            _modelStore2.default.updateAsync(componentId, function (model) {
	                model.email = value;
	                _validator2.default.clearSubmitError(model);
	                return _validator2.default.validateEmailAsync(componentId, model);
	            });
	        }
	    }, {
	        key: 'endEditPassword',
	        value: function endEditPassword(componentId) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.validation.hasPasswordBeenEdited = true;
	                _validator2.default.clearSubmitError(model);
	                return _validator2.default.validatePassword(model);
	            });
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(componentId, value) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.password = value;
	                _validator2.default.clearSubmitError(model);
	                _validator2.default.validatePassword(model);
	            });
	        }
	    }, {
	        key: 'clearPassword',
	        value: function clearPassword(componentId) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.password = '';
	                _validator2.default.validatePassword(model);
	            });
	        }
	    }, {
	        key: 'endEditConfirmedPassword',
	        value: function endEditConfirmedPassword(componentId) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.validation.hasConfirmedPasswordBeenEdited = true;
	                _validator2.default.clearSubmitError(model);
	                return _validator2.default.validateConfirmedPassword(model);
	            });
	        }
	    }, {
	        key: 'changeConfirmedPassword',
	        value: function changeConfirmedPassword(componentId, value) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.confirmedPassword = value;
	                _validator2.default.clearSubmitError(model);
	                _validator2.default.validateConfirmedPassword(model);
	            });
	        }
	    }, {
	        key: 'changeKeepLoggedIn',
	        value: function changeKeepLoggedIn(componentId) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.keepLoggedIn = !model.keepLoggedIn;
	                _validator2.default.clearSubmitError(model);
	            });
	        }
	    }, {
	        key: 'changeAcceptTerms',
	        value: function changeAcceptTerms(componentId) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.acceptTerms = !model.acceptTerms;
	                _validator2.default.clearSubmitError(model);
	                _validator2.default.validateAcceptTerms(model);
	            });
	        }
	    }, {
	        key: 'changeSendProductInformation',
	        value: function changeSendProductInformation(componentId) {
	            _modelStore2.default.update(componentId, function (model) {
	                model.sendProductInformation = !model.sendProductInformation;
	                _validator2.default.clearSubmitError(model);
	                if (!model.sendProductInformation) {
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsSendMeProductInformationUnchecked });
	                }
	            });
	        }
	    }, {
	        key: 'register',
	        value: function register(componentId) {
	            if (_uiStateStore2.default.getModel(componentId).form.uiState !== _uiState2.default.ready) {
	                return new Promise(function (resolve, reject) {
	                    return reject();
	                });
	            }
	
	            _validator2.default.enable();
	
	            return FormActions.validateAllAsync(componentId).then(function () {
	                _validator2.default.clearSubmitError(_modelStore2.default.getModel(componentId));
	            }).then(function () {
	                if (_modelStore2.default.getModel(componentId).validation.errors.acceptTerms !== '') {
	                    _jmServices2.default.trackEvent(componentId, {
	                        trackingValue: _trackingAction2.default.jlsGetStartedButtonClickedButFormIsInvalidDueToTcsCheckboxNotChecked
	                    });
	                }
	
	                if (_modelStore2.default.getModel(componentId).validation.hasErrors) {
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsGetStartedButtonClickedButFormIsInvalid });
	                    return new Promise(function (resolve) {
	                        return resolve();
	                    });
	                }
	
	                _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsGetStartedButtonClickedAndFormIsValid });
	
	                _formUiState2.default.setWaiting(componentId);
	
	                if (_paramStore2.default.getModel(componentId).websiteEndpoint) {
	                    return _clsServices2.default.registerWithWebsiteApi(componentId, {
	                        email: _modelStore2.default.getModel(componentId).email,
	                        password: _paramStore2.default.getModel(componentId).initialCohort === _initialCohort2.default.passwordlessRegistration ? null : _modelStore2.default.getModel(componentId).password,
	                        sendProductInformation: _modelStore2.default.getModel(componentId).sendProductInformation
	                    }).then(function (response) {
	                        if (response && response.error) {
	                            _modelStore2.default.updateAsync(componentId, function (model) {
	                                model.validation.errors.submitError = (0, _localization.localize)('error.generic');
	
	                                return _validator2.default.validateAllAsync(componentId, model).then(function () {
	                                    return _formUiState2.default.setReady(componentId);
	                                });
	                            });
	                        }
	                    });
	                }
	                return _clsServices2.default.register(componentId, {
	                    email: _modelStore2.default.getModel(componentId).email,
	                    password: _paramStore2.default.getModel(componentId).initialCohort === _initialCohort2.default.passwordlessRegistration ? null : _modelStore2.default.getModel(componentId).password,
	                    sendProductInformation: _modelStore2.default.getModel(componentId).sendProductInformation,
	                    keepLoggedIn: true, // By default registration persists KeepMeLoggedIn option at CLS side
	                    activate: _paramStore2.default.getModel(componentId).initialCohort === _initialCohort2.default.passwordlessRegistration
	                }).then(function (response) {
	                    if (response && response.error) {
	                        _modelStore2.default.updateAsync(componentId, function (model) {
	                            model.validation.errors.submitError = (0, _localization.localize)('error.generic');
	
	                            return _validator2.default.validateAllAsync(componentId, model).then(function () {
	                                return _formUiState2.default.setReady(componentId);
	                            });
	                        });
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'login',
	        value: function login(componentId) {
	            if (_uiStateStore2.default.getModel(componentId).form.uiState !== _uiState2.default.ready) {
	                return new Promise(function (resolve, reject) {
	                    return reject();
	                });
	            }
	
	            _validator2.default.enable();
	
	            return FormActions.validateAllAsync(componentId).then(function () {
	                _validator2.default.clearSubmitError(_modelStore2.default.getModel(componentId));
	            }).then(function () {
	                if (_modelStore2.default.getModel(componentId).validation.hasErrors) {
	                    // TODO: Tracking
	                    return new Promise(function (resolve) {
	                        return resolve();
	                    });
	                }
	
	                // TODO: Tracking
	
	                _formUiState2.default.setWaiting(componentId);
	                if (_paramStore2.default.getModel(componentId).websiteEndpoint) {
	                    return _clsServices2.default.loginWithWebsiteApi(componentId, {
	                        email: _modelStore2.default.getModel(componentId).email,
	                        password: _modelStore2.default.getModel(componentId).password,
	                        keepLoggedIn: _modelStore2.default.getModel(componentId).keepLoggedIn,
	                        clsProviderType: _clsProviderType2.default.standardProviderId
	                    }).then(function (response) {
	                        if (response && response.error) {
	                            _modelStore2.default.updateAsync(componentId, function (model) {
	
	                                if (response.invalidCredentials) {
	                                    model.validation.errors.email = (0, _localization.localize)('validation.invalid-credentials');
	                                    model.validation.hasErrors = true;
	
	                                    FormActions.clearPassword(componentId);
	
	                                    return new Promise(function (resolve) {
	                                        return resolve();
	                                    }).then(function () {
	                                        return _formUiState2.default.setReady(componentId);
	                                    });
	                                }
	
	                                model.validation.errors.submitError = (0, _localization.localize)('error.generic');
	
	                                return _validator2.default.validateAllAsync(componentId, model).then(function () {
	                                    return _formUiState2.default.setReady(componentId);
	                                });
	                            });
	                        }
	                    });
	                }
	                return _clsServices2.default.login(componentId, {
	                    email: _modelStore2.default.getModel(componentId).email,
	                    password: _modelStore2.default.getModel(componentId).password,
	                    keepLoggedIn: _modelStore2.default.getModel(componentId).keepLoggedIn,
	                    clsProviderType: _clsProviderType2.default.standardProviderId
	                }).then(function (response) {
	                    if (response && response.error) {
	                        _modelStore2.default.updateAsync(componentId, function (model) {
	
	                            if (response.invalidCredentials) {
	                                model.validation.errors.email = (0, _localization.localize)('validation.invalid-credentials');
	                                model.validation.hasErrors = true;
	
	                                FormActions.clearPassword(componentId);
	
	                                return new Promise(function (resolve) {
	                                    return resolve();
	                                }).then(function () {
	                                    return _formUiState2.default.setReady(componentId);
	                                });
	                            }
	
	                            model.validation.errors.submitError = (0, _localization.localize)('error.generic');
	
	                            return _validator2.default.validateAllAsync(componentId, model).then(function () {
	                                return _formUiState2.default.setReady(componentId);
	                            });
	                        });
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'forgotPassword',
	        value: function forgotPassword(componentId) {
	            if (_uiStateStore2.default.getModel(componentId).form.uiState !== _uiState2.default.ready) {
	                return new Promise(function (resolve, reject) {
	                    return reject();
	                });
	            }
	
	            _validator2.default.enable();
	
	            return FormActions.validateAllAsync(componentId);
	        }
	    }, {
	        key: 'validateAllAsync',
	        value: function validateAllAsync(componentId) {
	            return _modelStore2.default.updateAsync(componentId, function (model) {
	                model.validation.hasEmailBeenEdited = true;
	                model.validation.hasPasswordBeenEdited = model.passwordMode !== _passwordMode2.default.passwordless;
	                model.validation.hasConfirmedPasswordBeenEdited = model.passwordMode === _passwordMode2.default.standard;
	
	                return _validator2.default.validateAllAsync(componentId, model);
	            });
	        }
	    }, {
	        key: 'redirectToForgotPwd',
	        value: function redirectToForgotPwd(componentId) {
	            // Dirty lines to not wire own forgotPwd form and use existing login url to easier avoid breaking changes with
	            // implementers who cannot increment component version and add new mandatory component parameters
	            // at the same time.
	            window.top.location = _paramStore2.default.getModel(componentId).clsEndpoint + 'forgotpassword.aspx' + ('' + _paramStore2.default.getModel(componentId).clsLoginUrl.replace('/login.aspx', '').replace(/&amp;/g, '&')) + ('&force=1&email=' + encodeURIComponent(_modelStore2.default.getModel(componentId).email));
	        }
	    }]);
	
	    return FormActions;
	}();
	
	exports.default = FormActions;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _passwordMode = __webpack_require__(8);
	
	var _passwordMode2 = _interopRequireDefault(_passwordMode);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _emailRepository = __webpack_require__(20);
	
	var _emailRepository2 = _interopRequireDefault(_emailRepository);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Validator = function () {
	    function Validator() {
	        _classCallCheck(this, Validator);
	
	        this.enabled = false;
	    }
	
	    _createClass(Validator, [{
	        key: '_validateEmailAsync',
	        value: function _validateEmailAsync(componentId, model, force) {
	            var errors = model.validation.errors;
	
	            switch (model.formType) {
	                case _formType2.default.login:
	                case _formType2.default.register:
	                    {
	
	                        var forceByErrorType = false;
	                        var error = !model.email ? (0, _localization.localize)('validation.email.required') : '';
	
	                        if (!error && model.email.length > 70) {
	                            error = (0, _localization.localize)('validation.email.max-length');
	                            forceByErrorType = true;
	                        }
	
	                        error = error || (!this.emailRegexp.test(model.email) ? (0, _localization.localize)('validation.email.format') : '');
	
	                        if (!error) {
	                            model.validation.hasEmailBeenValid = true;
	                        }
	
	                        if (!force && !forceByErrorType && !model.validation.hasEmailBeenEdited && !model.validation.hasEmailBeenValid) {
	                            errors.email = '';
	                            return new Promise(function (resolve) {
	                                return resolve();
	                            });
	                        }
	
	                        if (error) {
	                            errors.email = error;
	                            return new Promise(function (resolve) {
	                                return resolve();
	                            });
	                        }
	
	                        var existCheck = _emailRepository2.default.isEmailExisting(componentId, model.email);
	                        var federatedCheck = _emailRepository2.default.isEmailFederated(componentId, model.email);
	
	                        return Promise.all([existCheck, federatedCheck]).catch(function (ex) {
	                            return new Promise(function (resolve) {
	                                return resolve({ error: true });
	                            });
	                        }).then(function (checkResults) {
	                            if (checkResults.error) {
	                                errors.email = (0, _localization.localize)('error.generic');
	                                return checkResults;
	                            }
	
	                            var isEmailExisting = checkResults[0].exists;
	                            var hasPassword = checkResults[0].hasPassword;
	                            var isEmailFederated = checkResults[1];
	
	                            if (!isEmailFederated && !isEmailExisting) {
	                                errors.email = '';
	                                return checkResults;
	                            }
	
	                            // Federated email warning has higher priority than existing email warning
	                            if (isEmailFederated) {
	                                var clsLoginUrl = '' + _paramStore2.default.getModel(componentId).clsLoginUrl + ('&email=' + encodeURIComponent(model.email));
	                                errors.email =
	                                /* eslint-disable quotes */
	                                (0, _localization.localize)('validation.email.federated-id').replace('{0}', '<a href="javascript: void(0)" onclick="event.stopPropagation();' + ('jwfLogin._Api.Links.federatedLoginLinkClicked(\'' + clsLoginUrl + '\',' + componentId + ')" ') + 'data-gaeventcategory="' + _paramStore2.default.getModel(componentId).tracking.ga.federatedLoginLink.category + '" data-gaeventaction="' + _paramStore2.default.getModel(componentId).tracking.ga.federatedLoginLink.action + '">').replace('{1}', '</a>');
	                                /* eslint-enable quotes */
	                            } else if (isEmailExisting) {
	
	                                if (model.formType === _formType2.default.login) {
	
	                                    if (hasPassword) {
	                                        errors.email = '';
	                                    } else {
	                                        // PWD less flow
	                                        _formActions2.default.redirectToForgotPwd(componentId);
	                                    }
	                                } else {
	                                    /* eslint-disable quotes */
	                                    errors.email = _paramStore2.default.getModel(componentId).disableRedirectToLogin ? (0, _localization.localize)('validation.email.existing-id-short') : (0, _localization.localize)('validation.email.existing-id').replace('{0}', '<a href=\'javascript: void(0)\' ' + 'onclick=\'event.stopPropagation();' + ('jwfLogin._Api.Links.existingLoginLinkClicked(' + hasPassword + ', ' + componentId + ')\' ') + 'data-gaeventcategory=\'' + _paramStore2.default.getModel(componentId).tracking.ga.existingLoginLink.category + '\' data-gaeventaction=\'' + _paramStore2.default.getModel(componentId).tracking.ga.existingLoginLink.action + '\'>').replace('{1}', '</a>');
	
	                                    /* eslint-enable quotes */
	                                }
	                            } else {
	                                errors.email = '';
	                            }
	
	                            return checkResults;
	                        });
	                    }
	
	                case _formType2.default.forgotPassword:
	                    {
	                        return new Promise(function (resolve) {
	                            return resolve();
	                        });
	                    }
	
	                default:
	                    {
	                        return new Promise(function (resolve) {
	                            return resolve();
	                        });
	                    }
	            }
	        }
	    }, {
	        key: 'validateEmailAsync',
	        value: function validateEmailAsync(componentId, model) {
	            var _this = this;
	
	            return this.executeIfEnabledAsync(function () {
	                return _this._validateEmailAsync(componentId, model, false).then(function () {
	                    return _this._updateHasErrors(model);
	                });
	            });
	        }
	
	        /* eslint-disable complexity */
	
	    }, {
	        key: '_validatePassword',
	        value: function _validatePassword(model, force) {
	            var errors = model.validation.errors;
	
	            switch (model.formType) {
	                case _formType2.default.login:
	                case _formType2.default.register:
	                    if (model.passwordMode === _passwordMode2.default.passwordless) {
	                        break;
	                    }
	
	                    var error = !model.password ? (0, _localization.localize)('validation.password.required') : '';
	                    error = error || (model.password.length < 6 ? (0, _localization.localize)('validation.password.min-length') : '');
	                    error = error || (model.password.length > 255 ? (0, _localization.localize)('validation.password.max-length') : '');
	
	                    if (!error) {
	                        model.validation.hasPasswordBeenValid = true;
	                    }
	
	                    this._validateConfirmedPassword(model, false);
	
	                    if (!force && !model.validation.hasPasswordBeenEdited && !model.validation.hasPasswordBeenValid) {
	                        break;
	                    }
	
	                    errors.password = error;
	
	                    break;
	
	                case _formType2.default.forgotPassword:
	                    break;
	
	                default:
	                    return;
	            }
	        }
	        /* eslint-enable complexity */
	
	    }, {
	        key: 'validatePassword',
	        value: function validatePassword(model) {
	            var _this2 = this;
	
	            return this.executeIfEnabled(function () {
	                _this2._validatePassword(model, false);
	                _this2._updateHasErrors(model);
	            });
	        }
	    }, {
	        key: '_validateConfirmedPassword',
	        value: function _validateConfirmedPassword(model, force) {
	            var errors = model.validation.errors;
	
	            switch (model.formType) {
	                case _formType2.default.login:
	                case _formType2.default.forgotPassword:
	                    break;
	
	                case _formType2.default.register:
	                    if (model.passwordMode !== _passwordMode2.default.standard) {
	                        break;
	                    }
	
	                    var error = model.confirmedPassword !== model.password ? (0, _localization.localize)('validation.confirm-password.mismatch') : '';
	
	                    if (!error) {
	                        model.validation.hasConfirmedPasswordBeenValid = true;
	                    }
	
	                    if (!force && !model.validation.hasConfirmedPasswordBeenEdited && !model.validation.hasConfirmedPasswordBeenValid) {
	                        break;
	                    }
	
	                    errors.confirmedPassword = error;
	
	                    break;
	
	                default:
	                    return;
	            }
	        }
	    }, {
	        key: 'validateConfirmedPassword',
	        value: function validateConfirmedPassword(model) {
	            var _this3 = this;
	
	            return this.executeIfEnabled(function () {
	                _this3._validateConfirmedPassword(model, false);
	                _this3._updateHasErrors(model);
	            });
	        }
	    }, {
	        key: '_validateAcceptTerms',
	        value: function _validateAcceptTerms(model) {
	            var errors = model.validation.errors;
	
	            switch (model.formType) {
	                case _formType2.default.login:
	                case _formType2.default.forgotPassword:
	                    break;
	
	                case _formType2.default.register:
	                    errors.acceptTerms = !model.acceptTerms ? (0, _localization.localize)('validation.accept-terms') : '';
	                    break;
	
	                default:
	                    return;
	            }
	        }
	    }, {
	        key: 'validateAcceptTerms',
	        value: function validateAcceptTerms(model) {
	            var _this4 = this;
	
	            return this.executeIfEnabled(function () {
	                _this4._validateAcceptTerms(model);
	                _this4._updateHasErrors(model);
	            });
	        }
	    }, {
	        key: 'validateAllAsync',
	        value: function validateAllAsync(componentId, model) {
	            var _this5 = this;
	
	            return this.executeIfEnabledAsync(function () {
	                return _this5._validateEmailAsync(componentId, model, true).then(function () {
	                    _this5._validatePassword(model, true);
	                    _this5._validateConfirmedPassword(model, true);
	                    _this5._validateAcceptTerms(model);
	                    _this5._updateHasErrors(model);
	                });
	            });
	        }
	    }, {
	        key: '_updateHasErrors',
	        value: function _updateHasErrors(model) {
	            model.validation.hasErrors = !!model.validation.errors.email || !!model.validation.errors.password || !!model.validation.errors.confirmedPassword || !!model.validation.errors.acceptTerms;
	        }
	    }, {
	        key: 'clearSubmitError',
	        value: function clearSubmitError(model) {
	            model.validation.errors.submitError = '';
	        }
	    }, {
	        key: 'set',
	        value: function set(model, validationModel) {
	            model.validation = validationModel;
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this.enabled = true;
	        }
	    }, {
	        key: 'executeIfEnabled',
	        value: function executeIfEnabled(func) {
	            if (!this.enabled) {
	                return new Promise(function (resolve, reject) {
	                    return reject();
	                });
	            }
	
	            return func();
	        }
	    }, {
	        key: 'executeIfEnabledAsync',
	        value: function executeIfEnabledAsync(func) {
	            if (!this.enabled) {
	                return new Promise(function (resolve) {
	                    return resolve();
	                });
	            }
	
	            return func();
	        }
	    }, {
	        key: 'emailRegexp',
	        get: function get() {
	            return (/^((?!(.+\.\.+))(?!(.+\.@+))(?!(^\.))([\w-+!#\$\.']+))@((?:[\w-]+\.)*\w[\w-]*)\.([a-z]{2,})$/i
	            );
	        }
	    }]);
	
	    return Validator;
	}();
	
	exports.default = new Validator();

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clsServices = __webpack_require__(21);
	
	var _clsServices2 = _interopRequireDefault(_clsServices);
	
	var _trackingAction = __webpack_require__(25);
	
	var _trackingAction2 = _interopRequireDefault(_trackingAction);
	
	var _jmServices = __webpack_require__(26);
	
	var _jmServices2 = _interopRequireDefault(_jmServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmailRepository = function () {
	    function EmailRepository() {
	        _classCallCheck(this, EmailRepository);
	
	        this.existingEmailCache = {};
	        this.federatedEmailCache = {};
	    }
	
	    _createClass(EmailRepository, [{
	        key: 'isEmailExisting',
	        value: function isEmailExisting(componentId, email) {
	            var _this = this;
	
	            if (this.existingEmailCache[email] !== undefined) {
	                return Promise.resolve(this.existingEmailCache[email]);
	            }
	
	            return _clsServices2.default.isEmailExisting(componentId, { email: email }).then(function (response) {
	
	                if (response.exists) {
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsTypedAlreadyExistingEmail });
	                }
	
	                _this.existingEmailCache[email] = { 'exists': response.exists, 'hasPassword': response.has_password };
	                return _this.existingEmailCache[email];
	            });
	        }
	    }, {
	        key: 'isEmailFederated',
	        value: function isEmailFederated(componentId, email) {
	            var _this2 = this;
	
	            if (this.federatedEmailCache[email] !== undefined) {
	                return Promise.resolve(this.federatedEmailCache[email]);
	            }
	
	            return _clsServices2.default.isEmailFederated(componentId, { email: email }).then(function (response) {
	
	                if (response.federated_auth_required) {
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsTypedFederatedEmail });
	                }
	
	                _this2.federatedEmailCache[email] = response.federated_auth_required;
	                return _this2.federatedEmailCache[email];
	            });
	        }
	    }]);
	
	    return EmailRepository;
	}();
	
	exports.default = new EmailRepository();

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ajaxCall = __webpack_require__(22);
	
	var _ajaxCall2 = _interopRequireDefault(_ajaxCall);
	
	var _ajaxUrl = __webpack_require__(24);
	
	var _ajaxUrl2 = _interopRequireDefault(_ajaxUrl);
	
	var _trackingAction = __webpack_require__(25);
	
	var _trackingAction2 = _interopRequireDefault(_trackingAction);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _jmServices = __webpack_require__(26);
	
	var _jmServices2 = _interopRequireDefault(_jmServices);
	
	var _errorLogger = __webpack_require__(23);
	
	var _errorLogger2 = _interopRequireDefault(_errorLogger);
	
	var _redirectUrl = __webpack_require__(27);
	
	var _redirectUrl2 = _interopRequireDefault(_redirectUrl);
	
	var _processType = __webpack_require__(28);
	
	var _processType2 = _interopRequireDefault(_processType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ClsServices = function () {
	    function ClsServices() {
	        _classCallCheck(this, ClsServices);
	    }
	
	    _createClass(ClsServices, null, [{
	        key: 'register',
	        value: function register(componentId, options) {
	            try {
	                if (!options.email || options.activate === undefined || options.activate === null || options.keepLoggedIn === undefined || options.keepLoggedIn === null || options.sendProductInformation === undefined || options.sendProductInformation === null) {
	                    throw new Error('JLS Missing ClsServices.register preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	                    url: _ajaxUrl2.default.cls.register.url.replace('{clsAbsUrl}', _paramStore2.default.getModel(componentId).clsEndpoint),
	                    method: _ajaxUrl2.default.cls.register.method,
	                    /* eslint-disable camelcase */
	                    requestData: {
	                        username: options.email,
	                        password: options.password,
	                        auto_login: !!options.keepLoggedIn,
	                        auto_email: !!options.sendProductInformation,
	                        client_id: _paramStore2.default.getModel(componentId).clsClientId,
	                        redirect_uri: _paramStore2.default.getModel(componentId).clsReturnUrl,
	                        ui_locales: _paramStore2.default.getModel(componentId).lang5,
	                        scope: ClsServices.clsScope,
	                        grant_type: ClsServices._clsGrantType,
	                        activate_email: !!options.activate
	                        /* eslint-enable camelcase */
	                    } }).then(function (responseData) {
	                    // onFulfilled
	                    try {
	                        if (_paramStore2.default.getModel(componentId).callbacks.successfulRegistrationAtClsSide) {
	                            _paramStore2.default.getModel(componentId).callbacks.successfulRegistrationAtClsSide();
	                        }
	
	                        _jmServices2.default.trackEvent(componentId, {
	                            trackingValue: _trackingAction2.default.jlsSuccessfulRegistrationAtClsSide
	                        });
	
	                        if (!options.sendProductInformation) {
	                            _jmServices2.default.trackEvent(componentId, {
	                                trackingValue: _trackingAction2.default.jlsSuccessfulRegistrationAtClsSideSendMeProductInformationUnchecked
	                            });
	                        }
	
	                        ClsServices._executeResponseForm(componentId, responseData, options.email, _processType2.default.register);
	                        return undefined;
	                    } catch (ex) {
	                        _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedRegistrationAtClsSide });
	                        _errorLogger2.default.log(ex);
	
	                        if (_paramStore2.default.getModel(componentId).callbacks.registration) {
	                            _paramStore2.default.getModel(componentId).callbacks.registration({
	                                email: options.email,
	                                data: responseData
	                            });
	                        }
	
	                        return { error: true };
	                    }
	                }, function (responseData) {
	                    // onRejected
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedRegistrationAtClsSide });
	
	                    if (_paramStore2.default.getModel(componentId).callbacks.registration) {
	                        _paramStore2.default.getModel(componentId).callbacks.registration({ email: options.email, data: responseData });
	                    }
	
	                    return { error: true };
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'login',
	        value: function login(componentId, options) {
	            try {
	                if (!options.email || !options.password || !options.clsProviderType || options.keepLoggedIn === undefined || options.keepLoggedIn === null) {
	                    options.password = '';
	                    throw new Error('JLS Missing ClsServices.login preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	                    url: _ajaxUrl2.default.cls.login.url.replace('{clsAbsUrl}', _paramStore2.default.getModel(componentId).clsEndpoint),
	                    method: _ajaxUrl2.default.cls.login.method,
	                    /* eslint-disable camelcase */
	                    requestData: {
	                        username: options.email,
	                        password: options.password,
	                        auto_login: options.keepLoggedIn,
	                        provider: options.clsProviderType,
	                        client_id: _paramStore2.default.getModel(componentId).clsClientId,
	                        redirect_uri: _paramStore2.default.getModel(componentId).clsReturnUrl,
	                        ui_locales: _paramStore2.default.getModel(componentId).lang5,
	                        scope: ClsServices.clsScope,
	                        grant_type: ClsServices._clsGrantType
	                        /* eslint-enable camelcase */
	                    } }).then(function (responseData) {
	                    // onFulfilled
	
	                    try {
	                        if (_paramStore2.default.getModel(componentId).callbacks.successfulLoginAtClsSide) {
	                            _paramStore2.default.getModel(componentId).callbacks.successfulLoginAtClsSide();
	                        }
	
	                        // TODO: Tracking
	                        ClsServices._executeResponseForm(componentId, responseData, options.email, _processType2.default.login);
	                        return undefined;
	                    } catch (ex) {
	                        // TODO: Tracking
	                        _errorLogger2.default.log(ex);
	
	                        return { error: true, generic: true };
	                    }
	                }, function () {
	                    // onRejected
	                    // TODO: Tracking
	                    return { error: true, invalidCredentials: true };
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'registerWithWebsiteApi',
	        value: function registerWithWebsiteApi(componentId, options) {
	            try {
	
	                if (!options.email || options.sendProductInformation === undefined || options.sendProductInformation === null) {
	                    throw new Error('JLS Missing ClsServices.register preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	                    url: _ajaxUrl2.default.website.register.url.replace('{websiteUrl}', _paramStore2.default.getModel(componentId).websiteEndpoint),
	                    method: _ajaxUrl2.default.website.register.method,
	                    /* eslint-disable camelcase */
	                    requestData: {
	                        email: options.email,
	                        password: options.password,
	                        sendProductInfo: !!options.sendProductInformation,
	                        channel: ''
	                        /* eslint-enable camelcase */
	                    } }).then(function (responseData) {
	                    // onFulfilled
	                    try {
	                        if (_paramStore2.default.getModel(componentId).callbacks.successfulRegistrationAtHtml5Side) {
	                            // TODO: check AutoLoginTicket
	                            _paramStore2.default.getModel(componentId).callbacks.successfulRegistrationAtHtml5Side(responseData.AutoLoginTicket);
	                        }
	
	                        _jmServices2.default.trackEvent(componentId, {
	                            trackingValue: _trackingAction2.default.jlsSuccessfulRegistrationAtClsSide
	                        });
	
	                        if (!options.sendProductInformation) {
	                            _jmServices2.default.trackEvent(componentId, {
	                                trackingValue: _trackingAction2.default.jlsSuccessfulRegistrationAtClsSideSendMeProductInformationUnchecked
	                            });
	                        }
	
	                        return undefined;
	                    } catch (ex) {
	                        _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedRegistrationAtClsSide });
	                        _errorLogger2.default.log(ex);
	
	                        if (_paramStore2.default.getModel(componentId).callbacks.registration) {
	                            _paramStore2.default.getModel(componentId).callbacks.registration({
	                                email: options.email,
	                                data: responseData
	                            });
	                        }
	
	                        return { error: true };
	                    }
	                }, function (responseData) {
	                    // onRejected
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedRegistrationAtClsSide });
	
	                    if (_paramStore2.default.getModel(componentId).callbacks.registration) {
	                        _paramStore2.default.getModel(componentId).callbacks.registration({ email: options.email, data: responseData });
	                    }
	
	                    return { error: true };
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'loginWithWebsiteApi',
	        value: function loginWithWebsiteApi(componentId, options) {
	            try {
	                if (!options.email || !options.password || !options.clsProviderType || options.keepLoggedIn === undefined || options.keepLoggedIn === null) {
	                    options.password = '';
	                    throw new Error('JLS Missing ClsServices.login preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	
	                    url: _ajaxUrl2.default.website.login.url.replace('{websiteUrl}', _paramStore2.default.getModel(componentId).websiteEndpoint),
	                    method: _ajaxUrl2.default.website.login.method,
	                    /* eslint-disable camelcase */
	                    requestData: {
	                        email: options.email,
	                        password: options.password
	                        /* eslint-enable camelcase */
	                    } }).then(function (responseData) {
	                    // onFulfilled
	
	                    try {
	                        if (_paramStore2.default.getModel(componentId).callbacks.successfulRegistrationAtHtml5Side) {
	                            // TODO: check AutoLoginTicket
	                            _paramStore2.default.getModel(componentId).callbacks.successfulRegistrationAtHtml5Side(responseData.AutoLoginTicket);
	                        }
	
	                        // TODO: Tracking
	                        return undefined;
	                    } catch (ex) {
	                        // TODO: Tracking
	                        _errorLogger2.default.log(ex);
	
	                        return { error: true, generic: true };
	                    }
	                }, function () {
	                    // onRejected
	                    // TODO: Tracking
	                    return { error: true, invalidCredentials: true };
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'canAutoLogin',
	        value: function canAutoLogin(componentId) {
	            try {
	                var paramStoreModel = _paramStore2.default.getModel(componentId);
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	                    url: _ajaxUrl2.default.cls.tryAutoLogin.url.replace('{clsAbsUrl}', paramStoreModel.clsEndpoint),
	                    method: _ajaxUrl2.default.cls.tryAutoLogin.method,
	                    requestData: {}
	                }).then(function (responseData) {
	                    // onFulfilled
	                    _jmServices2.default.trackEvent(componentId, {
	                        trackingValue: _trackingAction2.default.jlsSuccessfulTryAutoLoginAtClsSide
	                    });
	                    return { canAutoLogin: !!responseData.is_auto_login_available };
	                }, function (responseData) {
	                    // onRejected
	                    _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedTryAutoLoginAtClsSide });
	                    return { canAutoLogin: false };
	                });
	            } catch (ex) {
	                _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedTryAutoLoginAtClsSide });
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'autoLogin',
	        value: function autoLogin(componentId) {
	            try {
	                var paramStoreModel = _paramStore2.default.getModel(componentId);
	
	                return ClsServices.canAutoLogin(componentId).then(function (result) {
	                    if (!result.canAutoLogin) {
	                        return result;
	                    }
	
	                    // This is very NOT the seamless implementation
	                    var autoLoginUrl = _redirectUrl2.default.cls.autoLogin.replace('{clsAbsUrl}', paramStoreModel.clsEndpoint).replace('{clsClientId}', paramStoreModel.clsClientId).replace('{clsReturnUrl}', paramStoreModel.clsAutoLoginReturnUrl).replace('{lang5}', paramStoreModel.lang5);
	
	                    window.top.location = autoLoginUrl;
	                    return undefined;
	                });
	            } catch (ex) {
	                _jmServices2.default.trackEvent(componentId, { trackingValue: _trackingAction2.default.jlsFailedAutoLoginAtClsSide });
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'isEmailExisting',
	        value: function isEmailExisting(componentId, options) {
	            try {
	                if (!options.email) {
	                    throw new Error('JLS Missing ClsServices.isEmailExisting preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	                    url: _ajaxUrl2.default.cls.isEmailExists.url.replace('{clsAbsUrl}', _paramStore2.default.getModel(componentId).clsEndpoint),
	                    method: _ajaxUrl2.default.cls.isEmailExists.method,
	                    /* eslint-disable camelcase */
	                    requestData: {
	                        username: options.email,
	                        client_id: _paramStore2.default.getModel(componentId).clsClientId
	                        /* eslint-enable camelcase */
	                    } });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: 'isEmailFederated',
	        value: function isEmailFederated(componentId, options) {
	            try {
	                if (!options.email) {
	                    throw new Error('JLS Missing ClsServices.isDomainExisting preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: false,
	                    url: _ajaxUrl2.default.cls.isEmailFederated.url.replace('{clsAbsUrl}', _paramStore2.default.getModel(componentId).clsEndpoint),
	                    method: _ajaxUrl2.default.cls.isEmailFederated.method,
	                    /* eslint-disable camelcase */
	                    requestData: {
	                        username: options.email,
	                        client_id: _paramStore2.default.getModel(componentId).clsClientId
	                        /* eslint-enable camelcase */
	                    } });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: '_executeResponseForm',
	        value: function _executeResponseForm(instanceComponentId, responseData, email, processType) {
	            if (!responseData.form || responseData.error_type) {
	                throw new Error('JLS Missing ClsServices._executeResponseForm preconditions; ResponseData:                 ' + JSON.stringify(responseData));
	            }
	
	            var parameters = _paramStore2.default.getModel(instanceComponentId),
	                clsExecutionArea = document.getElementById(parameters.clsExecutionArea),
	
	            // We need this to differentiate between instances and CLS processes within a single instance
	            uniqueProcessId = instanceComponentId + '-' + new Date().getTime();
	
	            if (!clsExecutionArea) {
	                // Fall back to document body if running only at core level
	                clsExecutionArea = document.body;
	            }
	
	            // Render CLS Form into DOM
	            // TODO: Workaround to fix rendering clsForm.target
	            clsExecutionArea.innerHTML += '<div id=\'cls-form-container-' + uniqueProcessId + '\'                                        style=\'display: none\'>' + responseData.form + '<div>';
	
	            if (parameters.silentMode) {
	                if (processType === _processType2.default.login) {
	                    // Do not allow login in silent mode because many CLS flow renders end up in CLS side
	                    throw new Error('Login flow cannot be processed in silent Mode');
	                }
	
	                clsExecutionArea.innerHTML += '<iframe style=\'width: 1px; height: 1px; visibility: hidden\'                         data-componentId=\'' + instanceComponentId + '\'                         data-email=\'' + email + '\'                         data-process-type=\'' + processType + '\'                         id=\'silent-cls-operation-' + uniqueProcessId + '\'                         name=\'silent-cls-operation-' + uniqueProcessId + '\'></iframe>';
	
	                // Change Form POST target
	                // Note: Do not use existing references to the form to avoid chrome issues like:
	                // Form submission canceled because the form is not connected
	                document.getElementById('cls-form-container-' + uniqueProcessId).firstChild.target = 'silent-cls-operation-' + uniqueProcessId;
	
	                // Handle iframe onload
	                document.getElementById('silent-cls-operation-' + uniqueProcessId).onload = function (event) {
	                    var componentId = event.target.getAttribute('data-componentId'),
	                        emailAddress = event.target.getAttribute('data-email'),
	                        processBehaviour = event.target.getAttribute('data-process-type'),
	                        paramStore = jwfLogin._Api.paramStore(componentId);
	
	                    // Remove unused resources
	                    // TODO: This is OK only for Chrome
	                    event.target.remove();
	                    document.getElementById('cls-form-container-' + uniqueProcessId).remove();
	
	                    if (processBehaviour === jwfLogin._Api.ProcessType.register.toString() && paramStore.callbacks && paramStore.callbacks.registration) {
	                        paramStore.callbacks.registration({ email: emailAddress, data: 'OK' });
	                    }
	
	                    if (processBehaviour === jwfLogin._Api.ProcessType.tryAutoLogin.toString() && paramStore.callbacks && paramStore.callbacks.tryAutoLogin) {
	                        // TODO: Call tryAutoLogin callback in proper way
	                    }
	                };
	            }
	
	            // Submit form
	            // Note: Do not use existing references to the form to avoid chrome issues like:
	            // Form submission canceled because the form is not connected
	            document.getElementById('cls-form-container-' + uniqueProcessId).firstChild.submit();
	        }
	    }, {
	        key: 'clsScope',
	        get: function get() {
	            return 'openid offline_access';
	        }
	    }, {
	        key: '_clsGrantType',
	        get: function get() {
	            return 'code';
	        }
	    }]);
	
	    return ClsServices;
	}();
	
	exports.default = ClsServices;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _errorLogger = __webpack_require__(23);
	
	var _errorLogger2 = _interopRequireDefault(_errorLogger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AjaxCall = function () {
	    function AjaxCall() {
	        _classCallCheck(this, AjaxCall);
	    }
	
	    _createClass(AjaxCall, null, [{
	        key: 'call',
	        value: function call(options) {
	            try {
	                var isPost = options.method === 'POST';
	
	                var badRequest = isPost && !options.requestData;
	                if (options.isAsync === undefined || options.isAsync === null || !options.url || !options.method || badRequest) {
	                    AjaxCall._ignoreSensitiveData(options);
	                    throw new Error('JLS Missing AjaxCall.call preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return fetch(options.url, {
	                    credentials: 'include', // Send cookies of CORS request; Needed for GateKeeper to know AnonymousId;
	                    method: options.method,
	                    headers: {
	                        'Accept': 'application/json',
	                        'Content-Type': 'application/json'
	                    },
	                    body: isPost ? JSON.stringify(options.requestData) : undefined
	
	                }).catch(function (exception) {
	                    // The catch order is intentional. Catch only fetch network errors
	                    if (options.isAsync) {
	                        return new Promise(function (resolve) {
	                            try {
	                                AjaxCall._throwError('JLS Network error occurred: ' + options.url + ' ' + options.method);
	                            } catch (ex) {
	                                AjaxCall._logError(ex, options);
	                            }
	
	                            resolve();
	                        });
	                    }
	
	                    AjaxCall._throwError('JLS Network error occurred', options, null, exception);
	
	                    return new Promise(function (resolve, reject) {
	                        return reject();
	                    });
	                }).then(function (response) {
	                    if (!response) {
	                        return new Promise(function (resolve) {
	                            return resolve();
	                        });
	                    }
	
	                    try {
	                        if (options.isAsync) {
	                            try {
	                                return AjaxCall._getResponseDataAsync(options, response, false);
	                            } catch (ex) {
	                                AjaxCall._logError(ex, options, response);
	                            }
	
	                            return new Promise(function (resolve) {
	                                return resolve();
	                            });
	                        }
	
	                        return AjaxCall._getResponseDataAsync(options, response, true);
	                    } catch (ex) {
	                        AjaxCall._logError(ex, options, response);
	                        AjaxCall._throwError('JLS Ajax call failed', options, response);
	
	                        return new Promise(function (resolve, reject) {
	                            return reject();
	                        });
	                    }
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: '_getResponseDataAsync',
	        value: function _getResponseDataAsync(options, response, resolveResponse) {
	            if (response.status >= 200 && response.status <= 299) {
	                return new Promise(function (resolve) {
	                    return resolve(resolveResponse ? response.json() : undefined);
	                });
	            } else {
	                AjaxCall._throwError('JLS Ajax call failed: ' + options.url + ' ' + options.method);
	
	                return new Promise(function (resolve, reject) {
	                    return reject();
	                });
	            }
	        }
	    }, {
	        key: '_logError',
	        value: function _logError(ex, options, response) {
	            if (response && response.body && !response.bodyUsed) {
	                response.text().then(function (responseData) {
	                    AjaxCall._callErrorLogger(ex, options, response.status, responseData);
	                });
	            } else {
	                AjaxCall._callErrorLogger(ex, options, response && response.status, '');
	            }
	        }
	    }, {
	        key: '_callErrorLogger',
	        value: function _callErrorLogger(ex, requestOptions, responseStatus, responseData) {
	            _errorLogger2.default.log(ex, {
	                ajax: {
	                    requestOptions: requestOptions,
	                    responseStatus: responseStatus,
	                    responseData: responseData
	                }
	            });
	        }
	    }, {
	        key: '_throwError',
	        value: function _throwError(message, options, response, exception) {
	            if (options) {
	                AjaxCall._ignoreSensitiveData(options);
	            }
	
	            var errorTextParts = [];
	
	            errorTextParts.push(message);
	            errorTextParts.push(options && 'RequestOptions: ' + JSON.stringify(options));
	            errorTextParts.push(response && 'ResponseStatus: ' + response.status);
	            errorTextParts.push(exception && 'Exception: ' + JSON.stringify(exception));
	
	            var errorText = errorTextParts.filter(function (p) {
	                return !!p;
	            }).join(' ');
	
	            throw new Error(errorText);
	        }
	    }, {
	        key: '_ignoreSensitiveData',
	        value: function _ignoreSensitiveData(options) {
	            if (options.requestData) {
	                options.requestData.password = '';
	            }
	        }
	    }]);
	
	    return AjaxCall;
	}();
	
	exports.default = AjaxCall;

/***/ },
/* 23 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ErrorLogger = function () {
	    function ErrorLogger() {
	        _classCallCheck(this, ErrorLogger);
	    }
	
	    _createClass(ErrorLogger, null, [{
	        key: "log",
	        value: function log(ex, data) {
	            Raven.captureException(ex, {
	                extra: data
	            });
	        }
	    }]);
	
	    return ErrorLogger;
	}();
	
	exports.default = ErrorLogger;

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    jm: {
	        tracking: {
	            // Track events triggered by user
	            // IsAsyncCapable: True
	            // Called by: Entire app (during user clicking)
	            // Request payload: DTO { trackingEventId, trackingEventName }
	            createEvent: { url: '/svc/JlsService/Tracking/Event', method: 'POST' },
	
	            // Save client side error trace
	            // IsAsyncCapable: False
	            // Called by: Entire app (during error handling)
	            // Request payload: DTO { trace }
	            // Response payload: aggregateDError
	            // TODO: Change to a generic endpoint instead of jmGuru
	            reportClientError: { url: '/svc/JmGuruService/Tracking/ReportClientError', method: 'POST' }
	        }
	    },
	    cls: {
	        // Login
	        // IsAsyncCapable: False
	        // Called by: LoginView
	        // Request payload: DTO { username, password, client_id, grant_type, provider, scope, redirect_uri,
	        // auto_login, ui_locales }
	        // Response payload: DTO { error_code }
	        login: { url: '{clsAbsUrl}auth/v1/auth', method: 'POST' },
	
	        // Register
	        // IsAsyncCapable: False
	        // Called by: RegisterView, RegisterPromoView
	        // Request payload: DTO { username, password, client_id, grant_type, scope, redirect_uri, activate_email,
	        // auto_email, auto_login, ui_locales }
	        // Response payload: DTO { error_code }
	        register: { url: '{clsAbsUrl}auth/v1/signup', method: 'POST' },
	
	        // Check if auto login available for user to know if "Keep me logged in" previously checked in this device
	        // and still not logged out
	        // IsAsyncCapable: False
	        // Called by: LoginView
	        // Request payload: empty
	        // Response payload: DTO { is_auto_login_available }
	        tryAutoLogin: { url: '{clsAbsUrl}auth/v1/tryautologin', method: 'POST' },
	
	        // Check if an email is already registered or not
	        // IsAsyncCapable: False
	        // Called by: RegisterView, RegisterPromoView
	        // Request payload: DTO { username, client_id, }
	        // Response payload: DTO { exists, has_password }
	        isEmailExists: { url: '{clsAbsUrl}auth/v1/usernameexists', method: 'POST' },
	
	        // Check if an email needs to be logged in through the federated way
	        // IsAsyncCapable: False
	        // Called by: LoginView, RegisterView, RegisterPromoView
	        // Request payload: DTO { username, client_id, }
	        // Response payload: DTO { federated_auth_required }
	        isEmailFederated: { url: '{clsAbsUrl}auth/v1/federatedauthrequired', method: 'POST' }
	    },
	    website: {
	        // Register with website API
	        // IsAsyncCapable: False
	        // Called by: RegisterView
	        // Request payload: DTO { email, password, sendProductInfo }
	        // Response payload: DTO { error_code }
	        register: { url: '{websiteUrl}HostService/Authentication/RegisterAndLogin', method: 'POST' },
	
	        // Register with website API
	        // IsAsyncCapable: False
	        // Called by: LoginView
	        // Request payload: DTO { email, password }
	        // Response payload: DTO { error_code }
	        login: { url: '{websiteUrl}HostService/Authentication/LoginWithUsernameAndPassword', method: 'POST' }
	    },
	    localization: {
	        // Localization resource
	        // IsAsyncCapable: False
	        // Called by: Localization
	        // Response payload: Localization resource .json
	        resource: { url: '{rootUrl}resources/localization/{culture}.json', method: 'GET' }
	    }
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    jlsRegisterViewLoaded: 1800,
	
	    jlsTypedAlreadyExistingEmail: 1801,
	    jlsAlreadyExistingUserClickedLoginLink: 1802,
	
	    jlsTypedFederatedEmail: 1803,
	    jlsFederatedUserClickedLoginLink: 1804,
	
	    jlsGetStartedButtonClickedButFormIsInvalid: 1805,
	    jlsGetStartedButtonClickedButFormIsInvalidDueToTcsCheckboxNotChecked: 1806,
	    jlsGetStartedButtonClickedAndFormIsValid: 1807,
	
	    jlsSuccessfulRegistrationAtClsSide: 1808,
	    jlsSuccessfulRegistrationAtClsSideSendMeProductInformationUnchecked: 1809,
	    jlsFailedRegistrationAtClsSide: 1810,
	
	    jlsTermsLinkClicked: 1811,
	    jlsPrivacyPolicyLinkClicked: 1812,
	    jlsChooseOtherwiseLinkClicked: 1813,
	    jlsSendMeProductInformationUnchecked: 1814,
	
	    jlsFailedTryAutoLoginAtClsSide: 1815,
	    jlsSuccessfulTryAutoLoginAtClsSide: 1816,
	    jlsFailedAutoLoginAtClsSide: 1817
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ajaxCall = __webpack_require__(22);
	
	var _ajaxCall2 = _interopRequireDefault(_ajaxCall);
	
	var _ajaxUrl = __webpack_require__(24);
	
	var _ajaxUrl2 = _interopRequireDefault(_ajaxUrl);
	
	var _trackingAction = __webpack_require__(25);
	
	var _trackingAction2 = _interopRequireDefault(_trackingAction);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _errorLogger = __webpack_require__(23);
	
	var _errorLogger2 = _interopRequireDefault(_errorLogger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var JmServices = function () {
	    function JmServices() {
	        _classCallCheck(this, JmServices);
	    }
	
	    _createClass(JmServices, null, [{
	        key: 'trackEvent',
	        value: function trackEvent(componentId, options) {
	            try {
	                if (!options.trackingValue) {
	                    throw new Error('JLS Missing JmServices.trackEvent preconditions; Options: ' + JSON.stringify(options));
	                }
	
	                return _ajaxCall2.default.call({
	                    isAsync: options.isAsync === undefined ? true : options.isAsync,
	                    url: _ajaxUrl2.default.jm.tracking.createEvent.url,
	                    method: _ajaxUrl2.default.jm.tracking.createEvent.method,
	                    requestData: {
	                        trackingEventId: options.trackingValue,
	                        properties: { 'Container': _paramStore2.default.getModel(componentId).tracking.segment.containerProperty },
	                        trackingEventName: JmServices._findTrackingName(options.trackingValue)
	                    }
	                });
	            } catch (ex) {
	                _errorLogger2.default.log(ex);
	                throw ex;
	            }
	        }
	    }, {
	        key: '_findTrackingName',
	        value: function _findTrackingName(trackingValue) {
	            for (var trackingActionName in _trackingAction2.default) {
	                if (_trackingAction2.default.hasOwnProperty(trackingActionName) && _trackingAction2.default[trackingActionName] === trackingValue) {
	                    return trackingActionName;
	                }
	            }
	
	            return 'UNKNOWN';
	        }
	    }]);
	
	    return JmServices;
	}();
	
	exports.default = JmServices;

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	    // Note: lang2: Two letter lang code like XX
	    //       lang5: Five letter lang code like xx-YY
	
	    jm: {
	        register: {
	            // LMI standard TCS
	            // Params: jmLang5
	            termsOfService: 'https://secure.logmein.com/policies/termsandconditions.aspx?lang={lang5}',
	
	            // LMI standard PP
	            // Params: jmLang5
	            privacyPolicy: 'https://secure.logmein.com/policies/privacy.aspx?lang={lang5}'
	        }
	    },
	    cls: {
	        // Auto login user if "Keep me logged in" previously checked in this device and still not logged out
	        // Params: clsAbsUrl, clsClientId, clsReturnUrl, lang5
	        autoLogin: '{clsAbsUrl}auth/v1/autologin?client_id={clsClientId}&scope=openid%20offline_access' + '&redirect_uri={clsReturnUrl}&ui_locales={lang5}'
	    }
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	    register: 0,
	    login: 1,
	    tryAutoLogin: 2
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.localize = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _localizationManager = __webpack_require__(30);
	
	var _localizationManager2 = _interopRequireDefault(_localizationManager);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _ajaxUrl = __webpack_require__(24);
	
	var _ajaxUrl2 = _interopRequireDefault(_ajaxUrl);
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	__webpack_require__(32);
	
	__webpack_require__(33);
	
	__webpack_require__(34);
	
	__webpack_require__(35);
	
	__webpack_require__(36);
	
	__webpack_require__(37);
	
	__webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalizationFactory = function () {
	    function LocalizationFactory() {
	        _classCallCheck(this, LocalizationFactory);
	
	        this.localizationManager = null;
	        this.localize = this.localize.bind(this);
	        this.initLocalization = this.initLocalization.bind(this);
	        this.componentId = 0;
	    }
	
	    _createClass(LocalizationFactory, [{
	        key: 'initLocalization',
	        value: function initLocalization(componentId) {
	            this.componentId = componentId;
	            var localizationConfig = {
	                config: {
	                    defaultCulture: 'en-us',
	                    currentCulture: _paramStore2.default.getModel(this.componentId).lang5.toLowerCase(),
	                    loadResources: true,
	                    resourcePath: _ajaxUrl2.default.localization.resource.url.replace('{rootUrl}', _paramStore2.default.getModel(this.componentId).rootUrl)
	                }
	            };
	
	            this.localizationManager = new _localizationManager2.default(localizationConfig, function (url) {
	                return fetch(url).then(function (response) {
	                    return new Promise(function (resolve, reject) {
	                        if (response.status !== 200) {
	                            reject(response);
	                        }
	                        resolve(response.json());
	                    });
	                });
	            });
	
	            return this.localizationManager.loadPromise;
	        }
	    }, {
	        key: 'localize',
	        value: function localize() {
	            var overrideNodeIdRepresentation = (_paramStore2.default.getModel(this.componentId).lang5 + '.' + arguments[0]).toLowerCase(),
	                overrideNodeValue;
	
	            _uiStateStore2.default.getModel(this.componentId).form.localizationOverrides.map(function (override) {
	                if (Object.keys(override)[0].toLowerCase() === overrideNodeIdRepresentation) {
	                    overrideNodeValue = override[overrideNodeIdRepresentation];
	                }
	            });
	
	            if (overrideNodeValue) {
	                return overrideNodeValue;
	            }
	
	            return this.localizationManager.getString.apply(this.localizationManager, arguments);
	        }
	    }]);
	
	    return LocalizationFactory;
	}();
	
	var localizationFactory = new LocalizationFactory();
	
	exports.default = localizationFactory;
	var localize = exports.localize = localizationFactory.localize;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _localizationResourceCache = __webpack_require__(31);
	
	var _localizationResourceCache2 = _interopRequireDefault(_localizationResourceCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalizationManager = function (_LocalizationResource) {
	    _inherits(LocalizationManager, _LocalizationResource);
	
	    function LocalizationManager(localizationConfig, xhrGet) {
	        _classCallCheck(this, LocalizationManager);
	
	        var _this = _possibleConstructorReturn(this, (LocalizationManager.__proto__ || Object.getPrototypeOf(LocalizationManager)).call(this, localizationConfig, xhrGet));
	
	        _this.defaultCulture = localizationConfig.config.defaultCulture;
	        _this.currentCulture = localizationConfig.config.currentCulture;
	
	        _this.loadPromise = null;
	        if (localizationConfig.config.loadResources) {
	            _this.loadPromise = _this._loadDefaultCulture().then(function () {
	                return _this._loadCurrentCulture();
	            });
	        }
	
	        _this.localizationTasks = [];
	        return _this;
	    }
	
	    _createClass(LocalizationManager, [{
	        key: 'setDefaultCulture',
	        value: function setDefaultCulture(culture) {
	            this.defaultCulture = culture;
	            return this._loadDefaultCulture();
	        }
	    }, {
	        key: '_loadDefaultCulture',
	        value: function _loadDefaultCulture() {
	            return this.loadResources(this.defaultCulture);
	        }
	    }, {
	        key: '_loadCurrentCulture',
	        value: function _loadCurrentCulture() {
	            var _this2 = this;
	
	            return this.loadResources(this.currentCulture).then(function (result) {
	                return result;
	            }, function () {
	                return _this2.loadResources(_this2.defaultCulture);
	            });
	        }
	    }, {
	        key: '_runCurrentCultureTask',
	        value: function _runCurrentCultureTask(task) {
	            var _this3 = this;
	
	            return task(this.currentCulture).then(function (result) {
	                return result;
	            }, function () {
	                return task(_this3.defaultCulture);
	            });
	        }
	    }, {
	        key: 'setCurrentCulture',
	        value: function setCurrentCulture(culture) {
	            var _this4 = this;
	
	            this.currentCulture = culture;
	
	            var localizationPromises = [this._loadCurrentCulture()];
	
	            this.localizationTasks.map(function (task) {
	                var localizationTaskRunner = _this4._runCurrentCultureTask(task);
	
	                localizationPromises.push(localizationTaskRunner);
	            });
	
	            this.loadPromise = Promise.all(localizationPromises);
	            return this.loadPromise;
	        }
	    }, {
	        key: '_getResourceString',
	        value: function _getResourceString(key) {
	            var resourceString = this.getResource(this.currentCulture, key);
	
	            if (resourceString === null) {
	                resourceString = this.getResource(this.defaultCulture, key);
	            }
	            if (resourceString === null) {
	                resourceString = key;
	            }
	
	            return resourceString;
	        }
	    }, {
	        key: 'containsKey',
	        value: function containsKey(key) {
	            if (!key) {
	                return false;
	            }
	
	            return this.getResource(this.defaultCulture, key) !== null;
	        }
	    }, {
	        key: 'getString',
	        value: function getString(key, options) {
	            // guard clause
	            if (key === undefined || key === null) {
	                return '';
	            }
	
	            // get pluralized key
	            var pluralizedKey = key;
	
	            if (options && options.count !== undefined && options.count !== null && Number.isInteger(options.count)) {
	
	                if (options.count === 0 || options.count === 1) {
	                    pluralizedKey += '-singular';
	                } else if (options.count > 1) {
	                    pluralizedKey += '-plural';
	                }
	            }
	
	            var keyFound = this.containsKey(pluralizedKey);
	
	            // if the pluralized key exists and options.params is specified, do a recursive call,
	            //   fallback to pluralized key and string format arguments
	            if (keyFound && options && options.params !== undefined) {
	                var optionsParams = options.params ? options.params : [];
	                var params = [].concat.apply([pluralizedKey], optionsParams);
	
	                // NOTE: we do not pass options.default to the recursive call because keyFound == true
	                return this.getString.apply(this, params);
	            }
	
	            // use options.default if needed and specified, otherwise get resource string
	            var resourceString = void 0;
	
	            if (!keyFound && options && options.default !== undefined && options.default !== null) {
	                resourceString = options.default;
	            } else {
	                resourceString = this._getResourceString(pluralizedKey);
	            }
	
	            // replace string format arguments
	            var args = void 0;
	
	            if (options && options.params !== undefined) {
	                args = options.params;
	            } else {
	                args = Array.prototype.slice.call(arguments).slice(1);
	            }
	
	            args.filter(function (arg) {
	                return arg !== undefined;
	            }).map(function (arg, index) {
	                var argRegexp = void 0,
	                    argValue = void 0;
	
	                argRegexp = new RegExp('\\{' + index + '\\}', 'g');
	                argValue = arg.toString();
	
	                resourceString = resourceString.replace(argRegexp, argValue);
	            });
	
	            return resourceString;
	        }
	    }]);
	
	    return LocalizationManager;
	}(_localizationResourceCache2.default);
	
	exports.default = LocalizationManager;

/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalizationResourceCache = function () {
	    function LocalizationResourceCache(localizationConfig, xhrGet) {
	        _classCallCheck(this, LocalizationResourceCache);
	
	        this.xhrGet = xhrGet;
	
	        this.resourcePath = localizationConfig.config.resourcePath;
	
	        this.resources = {};
	    }
	
	    _createClass(LocalizationResourceCache, [{
	        key: 'loadResources',
	        value: function loadResources(culture) {
	            var _this = this;
	
	            return new Promise(function (resolve, reject) {
	                var cultureResourcePath = encodeURI(_this.resourcePath.replace('{culture}', culture));
	
	                if (_this.resources[culture]) {
	                    resolve(_this.resources[culture]);
	                } else {
	                    _this.resources[culture] = {};
	                    _this.xhrGet(cultureResourcePath).then(function (result) {
	                        _this.resources[culture] = result;
	                        resolve(result);
	                    }, function (rejection) {
	                        reject(rejection);
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'getResource',
	        value: function getResource(culture, key) {
	            var keyParts = key.split('.'),
	                resource = this.resources[culture] ? this.resources[culture] : null;
	
	            if (!resource) {
	                return null;
	            }
	
	            keyParts.map(function (keyPart) {
	                if (!resource) {
	                    return;
	                }
	
	                resource = resource[keyPart] ? resource[keyPart] : null;
	            });
	
	            return resource;
	        }
	    }]);
	
	    return LocalizationResourceCache;
	}();
	
	exports.default = LocalizationResourceCache;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\de-de.json";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\en-us.json";

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\es-es.json";

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\fr-fr.json";

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\it-it.json";

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\nl-nl.json";

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "resources\\localization\\pt-br.json";

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    standardProviderId: 'password',
	    federatedProviderId: 'federated'
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _uiState = __webpack_require__(10);
	
	var _uiState2 = _interopRequireDefault(_uiState);
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var loadingInterlude = 500;
	
	var FormUiState = function () {
	    function FormUiState() {
	        _classCallCheck(this, FormUiState);
	    }
	
	    _createClass(FormUiState, null, [{
	        key: 'setWaiting',
	        value: function setWaiting(componentId) {
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.form.uiState = _uiState2.default.waiting;
	            });
	        }
	    }, {
	        key: 'setReady',
	        value: function setReady(componentId) {
	            if (_uiStateStore2.default.getModel(componentId).form.uiState === _uiState2.default.waiting) {
	                setTimeout(function () {
	                    return FormUiState._setReadyState(componentId);
	                }, loadingInterlude);
	                return;
	            }
	
	            if (_uiStateStore2.default.getModel(componentId).form.uiState === _uiState2.default.ready) {
	                return;
	            }
	
	            FormUiState._setReadyState(componentId);
	        }
	    }, {
	        key: '_setReadyState',
	        value: function _setReadyState(componentId) {
	            _uiStateStore2.default.update(componentId, function (model) {
	                model.form.uiState = _uiState2.default.ready;
	            });
	        }
	    }]);
	
	    return FormUiState;
	}();
	
	exports.default = FormUiState;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _loginInput = __webpack_require__(42);
	
	var _loginInput2 = _interopRequireDefault(_loginInput);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailInput = function (_LoginComponent) {
	    _inherits(EmailInput, _LoginComponent);
	
	    function EmailInput(props) {
	        _classCallCheck(this, EmailInput);
	
	        return _possibleConstructorReturn(this, (EmailInput.__proto__ || Object.getPrototypeOf(EmailInput)).call(this, props));
	    }
	
	    _createClass(EmailInput, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(_loginInput2.default, {
	                componentId: this.state.componentId,
	                id: 'login-email',
	                type: 'text',
	                iconId: 'e-mail',
	                value: this.state.loginModel.email,
	                label: (0, _localization.localize)('form-components.email'),
	                maxLength: 71,
	                onFocus: function onFocus(e) {
	                    return _formActions2.default.startEditEmail(_this2.state.componentId);
	                },
	                onBlur: function onBlur(e) {
	                    return _formActions2.default.endEditEmail(_this2.state.componentId);
	                },
	                onChange: function onChange(e) {
	                    return _formActions2.default.changeEmail(_this2.state.componentId, e.target.value);
	                },
	                error: this.error });
	        }
	    }, {
	        key: 'error',
	        get: function get() {
	            return this.state.loginModel.validation.errors.email;
	        }
	    }]);
	
	    return EmailInput;
	}(_loginComponent2.default);
	
	exports.default = EmailInput;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(43);
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginInput = function (_LoginComponent) {
	    _inherits(LoginInput, _LoginComponent);
	
	    function LoginInput(props) {
	        _classCallCheck(this, LoginInput);
	
	        return _possibleConstructorReturn(this, (LoginInput.__proto__ || Object.getPrototypeOf(LoginInput)).call(this, props));
	    }
	
	    _createClass(LoginInput, [{
	        key: 'render',
	        value: function render() {
	            var placeholderClass = 'input-placeholder ' + (this.props.error ? 'error' : '') + ' ' + ('' + (this.props.value || /^\s+$/.test(this.props.value) ? 'filled' : ''));
	
	            var inputId = this.props.id;
	
	            // noinspection CheckTagEmptyBody
	            return React.createElement(
	                'div',
	                { className: placeholderClass },
	                this.props.error ? React.createElement('label', {
	                    className: 'input-error',
	                    htmlFor: inputId,
	                    dangerouslySetInnerHTML: { __html: this.props.error } }) : null,
	                React.createElement('input', { id: inputId,
	                    name: inputId,
	                    className: 'login-input',
	                    type: this.props.type,
	                    value: this.props.value,
	                    maxLength: this.props.maxLength,
	                    onChange: this.props.onChange,
	                    onFocus: this.props.onFocus,
	                    onBlur: this.props.onBlur }),
	                React.createElement(
	                    'label',
	                    { className: 'placeholder',
	                        htmlFor: inputId },
	                    this.props.label
	                )
	            );
	        }
	    }]);
	
	    return LoginInput;
	}(_loginComponent2.default);
	
	exports.default = LoginInput;

/***/ },
/* 43 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _loginInput = __webpack_require__(42);
	
	var _loginInput2 = _interopRequireDefault(_loginInput);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordInput = function (_LoginComponent) {
	    _inherits(PasswordInput, _LoginComponent);
	
	    function PasswordInput(props) {
	        _classCallCheck(this, PasswordInput);
	
	        return _possibleConstructorReturn(this, (PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call(this, props));
	    }
	
	    _createClass(PasswordInput, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(_loginInput2.default, {
	                componentId: this.state.componentId,
	                id: 'login-password',
	                type: 'password',
	                iconId: 'lock-on',
	                value: this.state.loginModel.password,
	                label: this.placeholder,
	                maxLength: 256,
	                onBlur: function onBlur(e) {
	                    return _formActions2.default.endEditPassword(_this2.state.componentId);
	                },
	                onChange: function onChange(e) {
	                    return _formActions2.default.changePassword(_this2.state.componentId, e.target.value);
	                },
	                error: this.error });
	        }
	    }, {
	        key: 'placeholder',
	        get: function get() {
	            return this.isRegister ? (0, _localization.localize)('form-components.password-register') : (0, _localization.localize)('form-components.password-login');
	        }
	    }, {
	        key: 'error',
	        get: function get() {
	            return this.state.loginModel.validation.errors.password;
	        }
	    }]);
	
	    return PasswordInput;
	}(_loginComponent2.default);
	
	exports.default = PasswordInput;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _localization = __webpack_require__(29);
	
	__webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPasswordLink = function (_LoginComponent) {
	    _inherits(ForgotPasswordLink, _LoginComponent);
	
	    function ForgotPasswordLink(props) {
	        _classCallCheck(this, ForgotPasswordLink);
	
	        return _possibleConstructorReturn(this, (ForgotPasswordLink.__proto__ || Object.getPrototypeOf(ForgotPasswordLink)).call(this, props));
	    }
	
	    _createClass(ForgotPasswordLink, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(
	                'div',
	                { className: 'forgot-password-placeholder' },
	                React.createElement(
	                    'a',
	                    { href: 'javascript:void(0)',
	                        onClick: function onClick() {
	                            return _formActions2.default.redirectToForgotPwd(_this2.state.componentId);
	                        } },
	                    (0, _localization.localize)('form-components.forgot-password')
	                )
	            );
	        }
	    }]);
	
	    return ForgotPasswordLink;
	}(_loginComponent2.default);
	
	exports.default = ForgotPasswordLink;

/***/ },
/* 46 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _loginCheckbox = __webpack_require__(48);
	
	var _loginCheckbox2 = _interopRequireDefault(_loginCheckbox);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _localization = __webpack_require__(29);
	
	__webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeepLoggedInCheckbox = function (_LoginComponent) {
	    _inherits(KeepLoggedInCheckbox, _LoginComponent);
	
	    function KeepLoggedInCheckbox(props) {
	        _classCallCheck(this, KeepLoggedInCheckbox);
	
	        return _possibleConstructorReturn(this, (KeepLoggedInCheckbox.__proto__ || Object.getPrototypeOf(KeepLoggedInCheckbox)).call(this, props));
	    }
	
	    _createClass(KeepLoggedInCheckbox, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (_paramStore2.default.getModel(this.state.componentId).disableKeepLoggedInCheckbox) {
	                return React.createElement('div', { className: 'keep-logged-in-placeholder' });
	            } else {
	                return React.createElement(
	                    'div',
	                    { className: 'keep-logged-in-placeholder' },
	                    React.createElement(_loginCheckbox2.default, {
	                        componentId: this.state.componentId,
	                        checked: this.state.loginModel.keepLoggedIn,
	                        onChange: function onChange(e) {
	                            return _formActions2.default.changeKeepLoggedIn(_this2.state.componentId);
	                        },
	                        label: (0, _localization.localize)('form-components.keep-logged-in') })
	                );
	            }
	        }
	    }]);
	
	    return KeepLoggedInCheckbox;
	}(_loginComponent2.default);
	
	exports.default = KeepLoggedInCheckbox;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(49);
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginCheckbox = function (_LoginComponent) {
	    _inherits(LoginCheckbox, _LoginComponent);
	
	    function LoginCheckbox(props) {
	        _classCallCheck(this, LoginCheckbox);
	
	        return _possibleConstructorReturn(this, (LoginCheckbox.__proto__ || Object.getPrototypeOf(LoginCheckbox)).call(this, props));
	    }
	
	    _createClass(LoginCheckbox, [{
	        key: 'render',
	        value: function render() {
	            var className = 'login-checkbox ' + (this.props.error ? 'error' : '');
	
	            /* eslint-disable max-len */
	            return React.createElement(
	                'div',
	                { className: className },
	                React.createElement(
	                    'label',
	                    { className: 'checkbox', onClick: this.props.onChange },
	                    React.createElement(
	                        'div',
	                        { className: 'checkbox-svg-placeholder',
	                            'data-gaeventcategory': this.props.gaEventCategory,
	                            'data-gaeventaction': this.props.gaEventAction },
	                        this.props.checked ? React.createElement(
	                            'svg',
	                            { className: 'checkbox-svg checked', viewBox: '0 0 20 20' },
	                            React.createElement('path', { d: 'M16.01,0H3.99C1.79,0,0,1.99,0,4.43v11.14C0,18.01,1.79,20,3.99,20h12.03c2.19,0,3.99-1.99,3.99-4.43V4.43 C20,1.99,18.21,0,16.01,0z M17.01,6.61l-8.9,8.9c-0.01,0.01-0.02,0.01-0.04,0.02C8.03,15.57,8,15.61,7.95,15.65 c-0.07,0.05-0.15,0.08-0.23,0.12c-0.05,0.03-0.1,0.06-0.15,0.08c-0.17,0.06-0.34,0.1-0.52,0.1c-0.17,0-0.35-0.04-0.51-0.1 c-0.03-0.01-0.06-0.02-0.08-0.03c-0.16-0.07-0.3-0.16-0.43-0.28C6.02,15.53,6,15.52,5.99,15.51c-0.01-0.01-0.02-0.04-0.03-0.05 c-0.03-0.04-0.07-0.07-0.11-0.11l-3-4c-0.5-0.66-0.36-1.6,0.3-2.1c0.66-0.5,1.6-0.36,2.1,0.3l1.96,2.62l7.68-7.68 c0.59-0.58,1.54-0.59,2.12,0C17.6,5.07,17.6,6.02,17.01,6.61z' })
	                        ) : React.createElement(
	                            'svg',
	                            { className: 'checkbox-svg', viewBox: '0 0 20 20' },
	                            React.createElement('path', { d: 'M16,20H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v12C20,18.2,18.2,20,16,20z M18,16V4 c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h12C17.1,18,18,17.1,18,16z' })
	                        )
	                    ),
	                    React.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.label },
	                        'data-gaeventcategory': this.props.gaEventCategory,
	                        'data-gaeventaction': this.props.gaEventAction,
	                        title: this.props.title ? this.props.title : '' })
	                ),
	                this.props.error ? React.createElement('span', { className: 'checkbox-error', dangerouslySetInnerHTML: { __html: this.props.error } }) : null
	            );
	            /* eslint-enable max-len */
	        }
	    }]);
	
	    return LoginCheckbox;
	}(_loginComponent2.default);
	
	exports.default = LoginCheckbox;

/***/ },
/* 49 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 50 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginFormHeader = function (_LoginComponent) {
	    _inherits(LoginFormHeader, _LoginComponent);
	
	    function LoginFormHeader(props) {
	        _classCallCheck(this, LoginFormHeader);
	
	        return _possibleConstructorReturn(this, (LoginFormHeader.__proto__ || Object.getPrototypeOf(LoginFormHeader)).call(this, props));
	    }
	
	    _createClass(LoginFormHeader, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'div',
	                { className: 'login-header' },
	                React.createElement(
	                    'h1',
	                    { className: 'title-text' },
	                    this.props.title
	                ),
	                this.props.subTitle ? this.props.subTitle : null
	            );
	        }
	    }]);
	
	    return LoginFormHeader;
	}(_loginComponent2.default);
	
	exports.default = LoginFormHeader;

/***/ },
/* 52 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginSubmitButton = function (_LoginComponent) {
	    _inherits(LoginSubmitButton, _LoginComponent);
	
	    function LoginSubmitButton(props) {
	        _classCallCheck(this, LoginSubmitButton);
	
	        return _possibleConstructorReturn(this, (LoginSubmitButton.__proto__ || Object.getPrototypeOf(LoginSubmitButton)).call(this, props));
	    }
	
	    _createClass(LoginSubmitButton, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'div',
	                { className: 'btn-submit-placeholder' },
	                React.createElement(
	                    'div',
	                    { className: 'submit-error' },
	                    this.error
	                ),
	                React.createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-submit' },
	                    (0, _localization.localize)('forms.login.submit')
	                )
	            );
	        }
	    }, {
	        key: 'error',
	        get: function get() {
	            return this.state.loginModel.validation.errors.submitError;
	        }
	    }]);
	
	    return LoginSubmitButton;
	}(_loginComponent2.default);
	
	exports.default = LoginSubmitButton;

/***/ },
/* 54 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _emailInput = __webpack_require__(41);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _passwordInput = __webpack_require__(44);
	
	var _passwordInput2 = _interopRequireDefault(_passwordInput);
	
	var _confirmPasswordInput = __webpack_require__(56);
	
	var _confirmPasswordInput2 = _interopRequireDefault(_confirmPasswordInput);
	
	var _productInformationCheckbox = __webpack_require__(57);
	
	var _productInformationCheckbox2 = _interopRequireDefault(_productInformationCheckbox);
	
	var _termsOfService = __webpack_require__(59);
	
	var _termsOfService2 = _interopRequireDefault(_termsOfService);
	
	var _registerSubmitButton = __webpack_require__(61);
	
	var _registerSubmitButton2 = _interopRequireDefault(_registerSubmitButton);
	
	var _formHeader = __webpack_require__(51);
	
	var _formHeader2 = _interopRequireDefault(_formHeader);
	
	var _passwordMode = __webpack_require__(8);
	
	var _passwordMode2 = _interopRequireDefault(_passwordMode);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Register = function (_LoginComponent) {
	    _inherits(Register, _LoginComponent);
	
	    function Register(props) {
	        _classCallCheck(this, Register);
	
	        return _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));
	    }
	
	    _createClass(Register, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(
	                'div',
	                { className: 'forms-register' },
	                React.createElement(_formHeader2.default, {
	                    componentId: this.state.componentId,
	                    title: this.titleText,
	                    subTitle: this.subTitle }),
	                React.createElement(
	                    'form',
	                    { className: 'login-form-content',
	                        noValidate: 'true',
	                        onSubmit: function onSubmit(e) {
	                            e.preventDefault();
	                            _formActions2.default.register(_this2.state.componentId);
	                        } },
	                    React.createElement(_emailInput2.default, { componentId: this.state.componentId }),
	                    this.passwordElements,
	                    React.createElement(_termsOfService2.default, { componentId: this.state.componentId }),
	                    React.createElement(_productInformationCheckbox2.default, { componentId: this.state.componentId }),
	                    React.createElement(_registerSubmitButton2.default, { componentId: this.state.componentId })
	                )
	            );
	        }
	    }, {
	        key: 'titleText',
	        get: function get() {
	            return this.isPromo ? (0, _localization.localize)('forms.register.title-promo') : (0, _localization.localize)('forms.register.title');
	        }
	    }, {
	        key: 'subTitle',
	        get: function get() {
	            var _this3 = this;
	
	            if (this.isPromo) {
	                return null;
	            }
	
	            return React.createElement(
	                'div',
	                { className: 'subtitle-text' },
	                React.createElement(
	                    'span',
	                    null,
	                    (0, _localization.localize)('forms.register.change-or')
	                ),
	                '\xA0',
	                React.createElement(
	                    'a',
	                    {
	                        href: 'javascript:void(0)',
	                        onClick: function onClick() {
	                            return _formActions2.default.changeFormType(_this3.state.componentId, _formType2.default.login);
	                        } },
	                    (0, _localization.localize)('forms.register.change-link')
	                )
	            );
	        }
	    }, {
	        key: 'passwordElements',
	        get: function get() {
	            switch (this.state.loginModel.passwordMode) {
	                case _passwordMode2.default.standard:
	                    return React.createElement(
	                        'div',
	                        null,
	                        React.createElement(_passwordInput2.default, { componentId: this.state.componentId }),
	                        React.createElement(_confirmPasswordInput2.default, { componentId: this.state.componentId })
	                    );
	
	                case _passwordMode2.default.singlePassword:
	                    return React.createElement(_passwordInput2.default, { componentId: this.state.componentId });
	
	                default:
	                    return null;
	            }
	        }
	    }]);
	
	    return Register;
	}(_loginComponent2.default);
	
	exports.default = Register;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _loginInput = __webpack_require__(42);
	
	var _loginInput2 = _interopRequireDefault(_loginInput);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfirmPasswordInput = function (_LoginComponent) {
	    _inherits(ConfirmPasswordInput, _LoginComponent);
	
	    function ConfirmPasswordInput(props) {
	        _classCallCheck(this, ConfirmPasswordInput);
	
	        return _possibleConstructorReturn(this, (ConfirmPasswordInput.__proto__ || Object.getPrototypeOf(ConfirmPasswordInput)).call(this, props));
	    }
	
	    _createClass(ConfirmPasswordInput, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(_loginInput2.default, {
	                componentId: this.state.componentId,
	                id: 'login-confirmed-password',
	                type: 'password',
	                iconId: 'lock-on',
	                value: this.state.loginModel.confirmedPassword,
	                label: (0, _localization.localize)('form-components.confirm-password'),
	                maxLength: 256,
	                onBlur: function onBlur(e) {
	                    return _formActions2.default.endEditConfirmedPassword(_this2.state.componentId);
	                },
	                onChange: function onChange(e) {
	                    return _formActions2.default.changeConfirmedPassword(_this2.state.componentId, e.target.value);
	                },
	                error: this.error });
	        }
	    }, {
	        key: 'error',
	        get: function get() {
	            return this.state.loginModel.validation.errors.confirmedPassword;
	        }
	    }]);
	
	    return ConfirmPasswordInput;
	}(_loginComponent2.default);
	
	exports.default = ConfirmPasswordInput;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _loginCheckbox = __webpack_require__(48);
	
	var _loginCheckbox2 = _interopRequireDefault(_loginCheckbox);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _localization = __webpack_require__(29);
	
	__webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductInformationCheckbox = function (_LoginComponent) {
	    _inherits(ProductInformationCheckbox, _LoginComponent);
	
	    function ProductInformationCheckbox(props) {
	        _classCallCheck(this, ProductInformationCheckbox);
	
	        return _possibleConstructorReturn(this, (ProductInformationCheckbox.__proto__ || Object.getPrototypeOf(ProductInformationCheckbox)).call(this, props));
	    }
	
	    _createClass(ProductInformationCheckbox, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            if (!this.state.uiState.form.showProductInformation) {
	                return null;
	            }
	
	            return React.createElement(
	                'div',
	                { className: 'show-product-information-placeholder' },
	                React.createElement(_loginCheckbox2.default, {
	                    componentId: this.state.componentId,
	                    checked: !this.state.loginModel.sendProductInformation,
	                    onChange: function onChange(e) {
	                        return _formActions2.default.changeSendProductInformation(_this2.state.componentId);
	                    },
	                    label: (0, _localization.localize)('form-components.product-information'),
	                    title: (0, _localization.localize)('form-components.product-information-title'),
	                    gaEventCategory: this.state.paramModel.tracking.ga.productInformationCheckBox.category,
	                    gaEventAction: this.state.paramModel.tracking.ga.productInformationCheckBox.action })
	            );
	        }
	    }]);
	
	    return ProductInformationCheckbox;
	}(_loginComponent2.default);
	
	exports.default = ProductInformationCheckbox;

/***/ },
/* 58 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _loginCheckbox = __webpack_require__(48);
	
	var _loginCheckbox2 = _interopRequireDefault(_loginCheckbox);
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _redirectUrl = __webpack_require__(27);
	
	var _redirectUrl2 = _interopRequireDefault(_redirectUrl);
	
	var _localization = __webpack_require__(29);
	
	__webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsOfService = function (_LoginComponent) {
	    _inherits(TermsOfService, _LoginComponent);
	
	    function TermsOfService(props) {
	        _classCallCheck(this, TermsOfService);
	
	        return _possibleConstructorReturn(this, (TermsOfService.__proto__ || Object.getPrototypeOf(TermsOfService)).call(this, props));
	    }
	
	    _createClass(TermsOfService, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(
	                'div',
	                { className: 'terms-of-service-placeholder' },
	                React.createElement(_loginCheckbox2.default, {
	                    componentId: this.state.componentId,
	                    checked: this.state.loginModel.acceptTerms,
	                    onChange: function onChange(e) {
	                        return _formActions2.default.changeAcceptTerms(_this2.state.componentId);
	                    },
	                    label: this.text,
	                    error: this.error,
	                    gaEventCategory: this.state.paramModel.tracking.ga.termsCheckBox.category,
	                    gaEventAction: this.state.paramModel.tracking.ga.termsCheckBox.action })
	            );
	        }
	    }, {
	        key: 'error',
	        get: function get() {
	            return this.state.loginModel.validation.errors.acceptTerms;
	        }
	    }, {
	        key: 'text',
	        get: function get() {
	            return (0, _localization.localize)('form-components.terms-of-service-a').replace('{0}', '<a target="_blank" href="' + _redirectUrl2.default.jm.register.termsOfService.replace('{lang5}', this.state.paramModel.lang5) + '" onclick="event.stopPropagation();jwfLogin._Api.Links.termsLinkClicked(' + this.state.componentId + ')" ' + 'data-gaeventcategory="' + this.state.paramModel.tracking.ga.termsLink.category + '" data-gaeventaction="' + this.state.paramModel.tracking.ga.termsLink.action + '">').replace('{1}', '</a>').replace('{2}', '<a target="_blank" href="' + _redirectUrl2.default.jm.register.privacyPolicy.replace('{lang5}', this.state.paramModel.lang5) + '" onclick="event.stopPropagation();jwfLogin._Api.Links.privacyLinkClicked(' + this.state.componentId + ')" ' + 'data-gaeventcategory="' + this.state.paramModel.tracking.ga.privacyLink.category + '" data-gaeventaction="' + this.state.paramModel.tracking.ga.privacyLink.action + '">').replace('{3}', '</a>').replace('{4}', '<a href="javascript: void(0)" ' + 'onclick="event.stopPropagation();jwfLogin._Api.showProductInformation(' + this.state.componentId + ')" data-gaeventcategory="' + this.state.paramModel.tracking.ga.chooseOtherwiseLink.category + '" data-gaeventaction="' + this.state.paramModel.tracking.ga.chooseOtherwiseLink.action + '">').replace('{5}', '</a>');
	        }
	    }]);
	
	    return TermsOfService;
	}(_loginComponent2.default);
	
	exports.default = TermsOfService;

/***/ },
/* 60 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _localization = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegisterSubmitButton = function (_LoginComponent) {
	    _inherits(RegisterSubmitButton, _LoginComponent);
	
	    function RegisterSubmitButton(props) {
	        _classCallCheck(this, RegisterSubmitButton);
	
	        return _possibleConstructorReturn(this, (RegisterSubmitButton.__proto__ || Object.getPrototypeOf(RegisterSubmitButton)).call(this, props));
	    }
	
	    _createClass(RegisterSubmitButton, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'div',
	                { className: 'btn-submit-placeholder' },
	                React.createElement(
	                    'div',
	                    { className: 'submit-error' },
	                    this.error
	                ),
	                React.createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-submit',
	                        'data-gaeventcategory': this.state.paramModel.tracking.ga.getStartedButton.category,
	                        'data-gaeventaction': this.state.paramModel.tracking.ga.getStartedButton.action },
	                    this.submitText
	                )
	            );
	        }
	    }, {
	        key: 'submitText',
	        get: function get() {
	            return this.isPromo ? (0, _localization.localize)('forms.register.submit-promo') : (0, _localization.localize)('forms.register.submit');
	        }
	    }, {
	        key: 'error',
	        get: function get() {
	            return this.state.loginModel.validation.errors.submitError;
	        }
	    }]);
	
	    return RegisterSubmitButton;
	}(_loginComponent2.default);
	
	exports.default = RegisterSubmitButton;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _formActions = __webpack_require__(18);
	
	var _formActions2 = _interopRequireDefault(_formActions);
	
	var _formType = __webpack_require__(7);
	
	var _formType2 = _interopRequireDefault(_formType);
	
	var _loginComponent = __webpack_require__(14);
	
	var _loginComponent2 = _interopRequireDefault(_loginComponent);
	
	var _formHeader = __webpack_require__(51);
	
	var _formHeader2 = _interopRequireDefault(_formHeader);
	
	var _emailInput = __webpack_require__(41);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _localization = __webpack_require__(29);
	
	__webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPassword = function (_LoginComponent) {
	    _inherits(ForgotPassword, _LoginComponent);
	
	    function ForgotPassword(props) {
	        _classCallCheck(this, ForgotPassword);
	
	        return _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props));
	    }
	
	    _createClass(ForgotPassword, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement(
	                'form',
	                { className: 'forms-forgot-password', noValidate: 'true', onSubmit: function onSubmit(e) {
	                        e.preventDefault();
	                        _formActions2.default.forgotPassword(_this2.state.componentId);
	                    } },
	                React.createElement(_formHeader2.default, { componentId: this.state.componentId, title: (0, _localization.localize)('forms.forgot-password.title') }),
	                React.createElement(
	                    'div',
	                    { className: 'login-form-content' },
	                    React.createElement(
	                        'div',
	                        { className: 'instruction-placeholder' },
	                        React.createElement(
	                            'span',
	                            null,
	                            (0, _localization.localize)('forms.forgot-password.instruction')
	                        )
	                    ),
	                    React.createElement(_emailInput2.default, { componentId: this.state.componentId }),
	                    React.createElement(
	                        'div',
	                        { className: 'btn-submit-placeholder' },
	                        React.createElement(
	                            'button',
	                            { onClick: function onClick() {
	                                    _formActions2.default.forgotPassword(_this2.state.componentId);
	                                },
	                                className: 'btn btn-submit' },
	                            (0, _localization.localize)('forms.forgot-password.submit')
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'btn-cancel-placeholder' },
	                        React.createElement(
	                            'button',
	                            { onClick: function onClick() {
	                                    _formActions2.default.changeFormType(_this2.state.componentId, _formType2.default.login);
	                                },
	                                className: 'btn btn-cancel' },
	                            (0, _localization.localize)('forms.forgot-password.cancel')
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ForgotPassword;
	}(_loginComponent2.default);
	
	exports.default = ForgotPassword;

/***/ },
/* 63 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _platforms = __webpack_require__(65);
	
	var _platforms2 = _interopRequireDefault(_platforms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlatformDetection = function () {
	    function PlatformDetection() {
	        _classCallCheck(this, PlatformDetection);
	    }
	
	    _createClass(PlatformDetection, null, [{
	        key: '_platform',
	        value: function _platform(name, isSupported) {
	            return {
	                name: name,
	                isSupported: isSupported
	            };
	        }
	    }, {
	        key: '_detectPlatform',
	        value: function _detectPlatform() {
	            var userAgent = navigator.userAgent.toLowerCase();
	
	            window.platformDetection = {
	                os: PlatformDetection.detectOs(userAgent),
	                browser: PlatformDetection.detectBrowser(userAgent)
	            };
	            // Sample usage:
	            // console.log(window.platformDetection.os.name); // e.g.: win
	            // console.log(window.platformDetection.os.isSupported);
	            // console.log(window.platformDetection.browser.name); // e.g.: chrome
	            // console.log(window.platformDetection.browser.isSupported);
	        }
	    }, {
	        key: 'detectOs',
	        value: function detectOs(userAgent) {
	
	            // Windows Phone must come first because its UA also contains "Android"
	            if (userAgent.indexOf('windows phone') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.os.winPhone, false);
	            }
	
	            // Android
	            if (userAgent.indexOf('android') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.os.android, false);
	            }
	
	            // iOS detection from: http://stackoverflow.com/a/9039885/177710
	            if (userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipod') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.os.ios, false);
	            }
	
	            if (userAgent.indexOf('mac os x') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.os.mac, true);
	            }
	
	            return PlatformDetection._platform(_platforms2.default.os.win, true);
	        }
	    }, {
	        key: 'detectBrowser',
	        value: function detectBrowser(userAgent) {
	
	            // Many new browser's user agent contains "chrome". We parse the more specific agents first, and parse
	            // the "real chrome" if no specific match was found.
	            if (userAgent.indexOf('edge/') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.edge, true);
	            }
	
	            if (userAgent.indexOf('firefox/') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.firefox, true);
	            }
	
	            if (userAgent.indexOf('chrome/') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.chrome, true);
	            }
	
	            if (userAgent.indexOf('safari/') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.safari, true);
	            }
	
	            if (userAgent.indexOf('msie 8') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.ie8, false);
	            }
	
	            if (userAgent.indexOf('msie 9') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.ie9, false);
	            }
	
	            if (userAgent.indexOf('msie 10') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.ie10, true);
	            }
	
	            if ((userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) && userAgent.indexOf('rv:11') !== -1) {
	                return PlatformDetection._platform(_platforms2.default.browser.ie11, true);
	            }
	
	            return PlatformDetection._platform(_platforms2.default.browser.safari, true);
	        }
	    }, {
	        key: 'os',
	        get: function get() {
	            if (!window.platformDetection) {
	                PlatformDetection._detectPlatform();
	            }
	            return window.platformDetection.os;
	        }
	    }, {
	        key: 'browser',
	        get: function get() {
	            if (!window.platformDetection) {
	                PlatformDetection._detectPlatform();
	            }
	            return window.platformDetection.browser;
	        }
	    }]);
	
	    return PlatformDetection;
	}();
	
	exports.default = PlatformDetection;

/***/ },
/* 65 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    os: {
	        win: 'win',
	        mac: 'mac',
	        android: 'android',
	        ios: 'ios',
	        winPhone: 'win-phone'
	    },
	    browser: {
	        ie8: 'ie8',
	        ie9: 'ie9',
	        ie10: 'ie10',
	        ie11: 'ie11',
	        chrome: 'chrome',
	        firefox: 'firefox',
	        safari: 'safari',
	        edge: 'edge'
	    }
	};

/***/ },
/* 66 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 67 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	var _modelStore = __webpack_require__(6);
	
	var _modelStore2 = _interopRequireDefault(_modelStore);
	
	var _uiStateStore = __webpack_require__(9);
	
	var _uiStateStore2 = _interopRequireDefault(_uiStateStore);
	
	var _formUiState = __webpack_require__(40);
	
	var _formUiState2 = _interopRequireDefault(_formUiState);
	
	var _localization = __webpack_require__(29);
	
	var _localization2 = _interopRequireDefault(_localization);
	
	var _initialCohort = __webpack_require__(4);
	
	var _initialCohort2 = _interopRequireDefault(_initialCohort);
	
	var _passwordMode = __webpack_require__(8);
	
	var _passwordMode2 = _interopRequireDefault(_passwordMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ParamManager = function () {
	    function ParamManager() {
	        _classCallCheck(this, ParamManager);
	    }
	
	    _createClass(ParamManager, null, [{
	        key: 'validateAndStore',
	        value: function validateAndStore(params, componentId) {
	            ParamManager._validateUserTracking(params);
	
	            var paramStoreModel = _paramStore2.default.getModel(componentId),
	                modelStoreModel = _modelStore2.default.getModel(componentId),
	                uiStateStoreModel = _uiStateStore2.default.getModel(componentId);
	
	            _localization2.default.initLocalization(componentId).then(function () {
	                _formUiState2.default.setReady(componentId);
	            });
	
	            if (params.formType) {
	                modelStoreModel.formType = params.formType;
	            }
	
	            if (params.formVariants) {
	                uiStateStoreModel.form.formVariants = params.formVariants;
	            }
	
	            if (params.localizationOverrides) {
	                uiStateStoreModel.form.localizationOverrides = params.localizationOverrides;
	            }
	
	            if (paramStoreModel.initialCohort === _initialCohort2.default.passwordlessRegistration) {
	                _modelStore2.default.update(componentId, function (model) {
	                    model.passwordMode = _passwordMode2.default.passwordless;
	                });
	            }
	
	            if (paramStoreModel.initialCohort === _initialCohort2.default.singlePasswordRegistration) {
	                _modelStore2.default.update(componentId, function (model) {
	                    model.passwordMode = _passwordMode2.default.singlePassword;
	                });
	            }
	        }
	
	        /* eslint-disable complexity */
	
	    }, {
	        key: '_validateUserTracking',
	        value: function _validateUserTracking(params) {
	            if (!params.tracking.ga) {
	                throw new Error('JLS Missing obligatory global parameter called tracking.ga');
	            }
	
	            if (!params.tracking.ga.termsCheckBox || !params.tracking.ga.termsCheckBox.category || !params.tracking.ga.termsCheckBox.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.termsCheckBox');
	            }
	
	            if (!params.tracking.ga.termsLink || !params.tracking.ga.termsLink.category || !params.tracking.ga.termsLink.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.termsLink');
	            }
	
	            if (!params.tracking.ga.privacyLink || !params.tracking.ga.privacyLink.category || !params.tracking.ga.privacyLink.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.privacyLink');
	            }
	
	            if (!params.tracking.ga.chooseOtherwiseLink || !params.tracking.ga.chooseOtherwiseLink.category || !params.tracking.ga.chooseOtherwiseLink.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called ' + 'tracking.ga.chooseOtherwiseLink');
	            }
	
	            if (!params.tracking.ga.productInformationCheckBox || !params.tracking.ga.productInformationCheckBox.category || !params.tracking.ga.productInformationCheckBox.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called ' + 'tracking.ga.productInformationCheckBox');
	            }
	
	            if (!params.tracking.ga.getStartedButton || !params.tracking.ga.getStartedButton.category || !params.tracking.ga.getStartedButton.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called tracking.ga.getStartedButton');
	            }
	
	            if (!params.tracking.ga.federatedLoginLink || !params.tracking.ga.federatedLoginLink.category || !params.tracking.ga.federatedLoginLink.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called ' + 'tracking.ga.federatedLoginLink');
	            }
	
	            if (!params.tracking.ga.existingLoginLink || !params.tracking.ga.existingLoginLink.category || !params.tracking.ga.existingLoginLink.action) {
	                throw new Error('JLS Missing or truncated obligatory global parameter called ' + 'tracking.ga.existingLoginLink');
	            }
	        }
	        /* eslint-enable complexity */
	
	    }]);
	
	    return ParamManager;
	}();
	
	exports.default = ParamManager;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _paramStore = __webpack_require__(3);
	
	var _paramStore2 = _interopRequireDefault(_paramStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CoreParamManager = function () {
	    function CoreParamManager() {
	        _classCallCheck(this, CoreParamManager);
	    }
	
	    _createClass(CoreParamManager, null, [{
	        key: 'validateAndStore',
	        value: function validateAndStore(params, componentId) {
	            CoreParamManager.validate(params);
	            CoreParamManager.store(params, componentId);
	        }
	    }, {
	        key: 'validate',
	        value: function validate(params) {
	            CoreParamManager._validateComponentParams(params);
	            CoreParamManager._validateClsParams(params);
	            CoreParamManager._validateErrorTrackingParams(params);
	            CoreParamManager._validateSegmentTrackingParams(params);
	        }
	    }, {
	        key: 'store',
	        value: function store(params, componentId) {
	            var paramStoreModel = _paramStore2.default.getModel(componentId);
	
	            paramStoreModel.instanceId = params.instanceId;
	            paramStoreModel.tracking = params.tracking;
	
	            paramStoreModel.lang5 = params.lang5;
	            paramStoreModel.rootUrl = params.rootUrl;
	
	            if (params.initialCohort) {
	                paramStoreModel.initialCohort = params.initialCohort;
	            }
	
	            if (params.targetCohort) {
	                paramStoreModel.targetCohort = params.targetCohort;
	            }
	
	            paramStoreModel.clsEndpoint = params.clsEndpoint;
	            paramStoreModel.clsClientId = params.clsClientId;
	            paramStoreModel.clsReturnUrl = params.clsReturnUrl;
	            paramStoreModel.clsLoginUrl = params.clsLoginUrl;
	            paramStoreModel.targetUrl = params.targetUrl;
	
	            paramStoreModel.websiteEndpoint = params.websiteEndpoint;
	            paramStoreModel.disableRedirectToLogin = params.disableRedirectToLogin;
	            paramStoreModel.disableKeepLoggedInCheckbox = params.disableKeepLoggedInCheckbox;
	
	            // Tracking source overrides
	            // Encode full URL as part of the returnUrl section and used to redirect not for XHRs.
	            // Double encode sources for sure
	            var registrationSourceURIPart = 'registrationSource=' + encodeURIComponent(params.tracking.segment.registrationSource);
	            var loginSourceURIPart = '&loginSource=' + encodeURIComponent(params.tracking.segment.loginSource);
	            var targetUrlURIPart = paramStoreModel.targetUrl ? '&fwdto=' + encodeURIComponent(params.targetUrl) : '';
	
	            var clsUrlQueryString = '' + registrationSourceURIPart + loginSourceURIPart + targetUrlURIPart;
	            var encodedClsUrlQueryString = encodeURIComponent(clsUrlQueryString);
	
	            paramStoreModel.clsAutoLoginReturnUrl = paramStoreModel.clsReturnUrl.replace('TRACKING_SOURCE_PLACEHOLDER', encodedClsUrlQueryString);
	
	            paramStoreModel.clsReturnUrl = paramStoreModel.clsReturnUrl.replace('TRACKING_SOURCE_PLACEHOLDER', clsUrlQueryString);
	
	            paramStoreModel.clsLoginUrl = paramStoreModel.clsLoginUrl.replace('TRACKING_SOURCE_PLACEHOLDER', encodedClsUrlQueryString);
	
	            if (params.clsExecutionArea) {
	                paramStoreModel.clsExecutionArea = params.clsExecutionArea;
	            }
	
	            paramStoreModel.sentryUrl = params.sentryUrl;
	            paramStoreModel.userLogData = params.userLogData;
	
	            if (params.callbacks) {
	                paramStoreModel.callbacks = params.callbacks;
	            }
	
	            if (params.silentMode) {
	                paramStoreModel.silentMode = params.silentMode;
	            }
	        }
	    }, {
	        key: 'warnImplementer',
	        value: function warnImplementer(nonSupportedItem) {
	            console.warn(nonSupportedItem + ' no longer supported!!!');
	        }
	    }, {
	        key: '_validateComponentParams',
	        value: function _validateComponentParams(params) {
	            if (!params.instanceId) {
	                throw new Error('JLS Missing obligatory global parameter called instanceId');
	            }
	
	            if (!params.rootUrl) {
	                throw new Error('JLS Missing obligatory global parameter called rootUrl');
	            }
	
	            if (!params.lang5) {
	                throw new Error('JLS Missing obligatory global parameter called lang5');
	            }
	        }
	    }, {
	        key: '_validateClsParams',
	        value: function _validateClsParams(params) {
	            if (!params.clsEndpoint) {
	                throw new Error('JLS Missing obligatory global parameter called clsEndpoint');
	            }
	
	            if (!params.clsClientId) {
	                throw new Error('JLS Missing obligatory global parameter called clsClientId');
	            }
	
	            if (!params.clsReturnUrl) {
	                throw new Error('JLS Missing obligatory global parameter called clsReturnUrl');
	            }
	
	            if (!params.clsLoginUrl) {
	                throw new Error('JLS Missing obligatory global parameter called clsLoginUrl');
	            }
	        }
	    }, {
	        key: '_validateErrorTrackingParams',
	        value: function _validateErrorTrackingParams(params) {
	            if (!params.sentryUrl) {
	                throw new Error('JLS Missing obligatory global parameter called sentryUrl');
	            }
	
	            if (!params.userLogData) {
	                throw new Error('JLS Missing obligatory global parameter called userLogData');
	            }
	
	            if (!params.userLogData.anonymousId) {
	                throw new Error('JLS Missing obligatory global parameter called userLogData.anonymousId');
	            }
	
	            if (!params.userLogData.lang) {
	                throw new Error('JLS Missing obligatory global parameter called userLogData.lang');
	            }
	        }
	    }, {
	        key: '_validateSegmentTrackingParams',
	        value: function _validateSegmentTrackingParams(params) {
	            if (!params.tracking) {
	                throw new Error('JLS Missing obligatory global parameter called tracking');
	            }
	
	            if (!params.tracking.segment) {
	                throw new Error('JLS Missing obligatory global parameter called tracking.segment');
	            }
	
	            if (!params.tracking.segment.containerProperty) {
	                throw new Error('JLS Missing obligatory global parameter called tracking.segment.containerProperty');
	            }
	
	            if (!params.tracking.segment.registrationSource) {
	                throw new Error('JLS Missing obligatory global parameter called tracking.segment.registrationSource');
	            }
	
	            if (!params.tracking.segment.loginSource) {
	                throw new Error('JLS Missing obligatory global parameter called tracking.segment.loginSource');
	            }
	        }
	    }]);
	
	    return CoreParamManager;
	}();
	
	exports.default = CoreParamManager;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** jwf-login.js
 **/